<template>
  <div class="job-charges-main" id="jobChargesMain">
    <div class="job-charges-main-left" :style="{ width: openInputs ? 'calc(100% - 300px)' : '100%' }">
      <div class="top-section" :style="{ height: openInputs ? '50%' : '100%', marginBottom: '3px' }">
        <div class="left-menu" ref="leftMenu">
          <Menus :menu="menu" @menuClicked="menuClicked" />
          <div
            v-if="mountedPromisesFulfilledCount < mountedPromises.length"
            class="loading-bar-container"
            :style="loadingBarContainerStyling"
          >
            <div class="loading-bar-text">
              {{ loadingBarText }}
            </div>
            <div class="loading-bar" :style="loadingBarStyling"></div>
          </div>
        </div>
        <div class="top-section-content" style="overflow: hidden">
          <div class="top-filter-section">
            <Dropdown
              placeholder="Query By"
              style="width: 20%; margin-left: 5px"
              :items="queryBy"
              itemKey="Job Charges View Option"
              :selectedObject.sync="selectedQuery"
              :isDisabled="viewModePK || jobNoLoad"
            />
            <div v-if="selectedQuery ? selectedQuery.item == 2 : false" style="width: 40%; margin-left: 5px">
              <InputQuery
                placeholder="Project No."
                :isRequired="true"
                :items="projectNoList"
                itemKey="Project No"
                :errorMessage.sync="projectNoError"
                :selectedObject.sync="selectedProject"
                @selected="getJobs('getProjectNo', ...arguments)"
                :isDisabled="viewModePK"
                :search.sync="freeTextJobProjNo"
                :allowFreeText="true"
              />
              <Input
                :regex="{ regex: /(\d)/g, live: true }"
                :inputValue.sync="settingsitem"
                placeholder="No of Rows Shown"
                style="width: 50%; margin-right: 5px"
                textType="number"
                @focusChanged="jobListRefresh"
                :isDisabled="viewModePK"
              />
            </div>
            <div style="width: 40%; margin-left: 5px; display: flex; flex-direction: row">
              <InputQuery
                placeholder="Job No."
                :showDesc="false"
                :isRequired="true"
                :items="jobNoList"
                itemKey="Job No"
                :errorMessage.sync="jobNoError"
                :selectedObject.sync="selectedJob"
                @selected="getJobs('getJobNo', ...arguments)"
                :allowFreeText="true"
                ref="jobnoinput"
                :isDisabled="viewModePK || jobNoLoad"
                :search.sync="freeTextJobProjNo"
              />
              <Input
                :regex="{ regex: /(\d)/g, live: true }"
                :inputValue.sync="settingsitem"
                placeholder="No of Rows Shown"
                style="width: fit-content; margin-right: 5px"
                textType="number"
                @focusChanged="jobListRefresh"
                :isDisabled="viewModePK"
              />
            </div>
            <div style="width: 40%; display: flex; align-items: center">
              <span>Job Status: </span>
              <div
                :style="{
                  backgroundColor: jobStatus.color,
                  padding: '5px',
                  marginLeft: '5px',
                  borderRadius: '5px',
                  color: 'white',
                  pointerEvents: 'none',
                }"
              >
                {{ jobStatus.text }}
              </div>
            </div>
          </div>
          <div class="top-details-section" :style="{ height: 'calc(100% - 30px)' }">
            <div class="top-left-details">
              <div class="left-section-boxes-container" ref="boxes-section">
                <div class="boxes-item space">
                  <span>Amt Bill Excl. Tax</span>
                  <span style="margin-bottom: 2px" class="currency">{{
                    getCostingAnalysisSumByJobData['amtBilledExclTax']
                  }}</span>
                </div>
                <div class="boxes-item space">
                  <span>Tax</span>
                  <span style="margin-bottom: 2px" class="currency">{{ getCostingAnalysisSumByJobData['tax'] }}</span>
                </div>
                <div class="boxes-item space">
                  <span>Cost Excl. Tax</span>
                  <span style="margin-bottom: 2px" class="currency">{{
                    getCostingAnalysisSumByJobData['costExclTax']
                  }}</span>
                </div>
                <div class="boxes-item space">
                  <span>Gross Profit</span>
                  <span style="margin-bottom: 2px" class="currency">{{
                    getCostingAnalysisSumByJobData['grossProfit']
                  }}</span>
                </div>
                <div class="boxes-item space">
                  <span>G. Profit Margin %</span>
                  <span style="margin-bottom: 2px" class="currency">{{
                    getCostingAnalysisSumByJobData['gProfitMargin']
                  }}</span>
                </div>
                <div class="boxes-item">
                  <span>Accrued Revenue</span>
                  <span class="currency" style="padding-right: 5px">{{
                    sellingMultiCurr ? 'N/A' : `${sellingFCurr || 'MYR'} ${accruedRevForeign}`
                  }}</span>
                  <span class="currency" style="background-color: #7b9aff; padding-right: 5px; color: white"
                    >MYR {{ accruedRev }}</span
                  >
                </div>
                <div class="boxes-item">
                  <span>Accrued Expenses</span>
                  <span class="currency" style="padding-right: 5px">{{
                    buyingMultiCurr ? 'N/A' : `${buyingFCurr || 'MYR'} ${accruedExpensesForeign}`
                  }}</span>
                  <span class="currency" style="background-color: #7b9aff; padding-right: 5px; color: white"
                    >MYR {{ accruedExpenses }}</span
                  >
                </div>
              </div>
              <div class="tablebox-container" :style="tableHeight">
                <TableBox
                  v-if="showJobCharges"
                  title="Job Charges Details"
                  style="height: 100%; width: 100%; padding: 3px"
                  :tableData="tableListToggle"
                  :dataType="tableListToggleDataType"
                  :selectedRow.sync="selectedTableListToggle"
                  @rowSelected="jobChargesSelected"
                  :maxSelection="1"
                  :hideColumns="['PV', 'PVAP', 'TxnID', 'APInvoice', 'ARInvoice', '#']"
                  :loading="loading"
                />
                <!-- <TableBox title="Job Charges Details" style="height:100%; width: 100%; padding: 3px" :tableData="jobChargesList" :dataType="tableDataType" :selectedRow.sync="selectedJobCharges"  :maxSelection="1" :hideColumns="['PV', 'PVAP', 'TxnID', 'APInvoice', 'ARInvoice']" /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="openInputs"
        class="bottom-section"
        :style="{ height: openInputs ? '50%' : '100%', justifyContent: 'end', marginTop: '3px' }"
      >
        <div v-if="selectedDC.length < 2" class="bottom-section-content">
          <div
            style="
              display: flex;
              flex-direction: column;
              padding-bottom: 10px;
              padding-left: 5px;
              width: 40%;
              margin-right: 5px;
            "
          >
            <InputQuery
              :isRequired="true"
              :isDisabled="viewMode"
              style="width: 100%"
              placeholder="Charges Code"
              :errorMessage.sync="chargesCodeError"
              :items="chargeCodeList"
              itemKey="Income Code"
              descKey="Description"
              :selectedObject.sync="selectedChargesCode"
            />
            <InputQuery
              :isDisabled="viewMode"
              style="width: 100%"
              placeholder="Container No"
              :items="containerList"
              itemKey="Cont No"
              descKey="Container No"
              :selectedObject.sync="selectedCont"
            />
            <InputQuery
              :isDisabled="viewMode"
              placeholder="Cost Code"
              style="width: 100%"
              :items="costCodeList"
              itemKey="Cost Code"
              descKey="Cost Desc"
              :selectedObject.sync="jobChargesDetails['costCode']"
            />
            <InputQuery
              :isDisabled="viewMode"
              placeholder="Consignment No"
              style="width: 100%"
              :items="consignmentlist"
              itemKey="Consignment No"
              :selectedObject.sync="selectedCN"
            />
            <div style="display: flex; flex-direction: row">
              <Input
                :isDisabled="viewMode"
                :inputValue.sync="jobChargesDetails['docRefNo']"
                style="margin-right: 5px; width: 100%"
                placeholder="Doc Ref. No"
                validator="alphanumeric,25"
              />
              <Input
                :isDisabled="viewMode"
                :inputValue.sync="jobChargesDetails['docType']"
                placeholder="Doc Ref. Type"
                style="width: 100%"
                validator="alphanumeric,10"
              />
            </div>
            <Input
              v-if="enableVendorRebate !== 'N'"
              :isDisabled="viewMode"
              :inputValue.sync="jobChargesDetails['vendorRebate']"
              placeholder="Vendor Rebate"
              style="width: 50%; margin-right: 7px"
              textType="number"
              :regex="{ regex: /^\d+(\.\d{0,2})?/g, live: true }"
            />
            <Dropdown
              :isDisabled="viewMode"
              style="width: 50%; margin-right: 5px; margin-bottom: 3px"
              placeholder="Adjustment Type"
              :items="adjustmentType"
              itemKey="AdjstType"
              :selectedObject.sync="jobChargesDetails['AdjType']"
            />
            <Input
              :isDisabled="viewMode"
              :inputValue.sync="jobChargesDetails['remark']"
              placeholder="Remarks"
              style="width: 100%; margin-right: 5px"
            />
            <div v-if="jobChargesDetails['userID']" style="display: flex; flex-direction: row">
              <Input
                :inputValue.sync="jobChargesDetails['userID']"
                style="width: 100%; margin-right: 3px"
                :isDisabled="true"
                placeholder="User ID"
              />
              <div style="display: flex; flex-direction: column; width: 100%">
                <Input
                  :inputValue.sync="jobChargesDetails['dateUpdate']"
                  style="width: 100%; margin-right: 3px"
                  :isDisabled="true"
                  placeholder="Date"
                />
                <div style="display: flex; flex-direction: row; width: 100%">
                  <Input
                    :inputValue.sync="jobChargesDetails['expenseItem']"
                    style="width: 100%"
                    :isDisabled="true"
                    placeholder="Expense Item"
                  />
                  <!-- <span style="margin-right: 5px; font-weight: bold">Expense Item</span>
                  <span  class="block-section">{{jobChargesDetails['expenseItem'] ? jobChargesDetails['expenseItem'] : 'N' }}</span> -->
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; flex-direction: column">
            <ForeignCurrency
              :details="foreignDetails"
              :payableChecking="payableChecking"
              :viewMode="viewMode && !editSelling"
              :action="action"
              :recordSource="editSelling"
              ref="foreignCurrency"
            >
              <div slot="buying-first-col">
                <Dropdown
                  placeholder="Payee Type"
                  :isRequired="true"
                  :items="payeeTypeList"
                  :isDisabled="viewMode"
                  itemKey="Party"
                  :selectedObject.sync="selectedPayeeType"
                  @selected="payeeTypeSelected"
                  :errorMessage.sync="payeeTypeError"
                />
              </div>
              <div slot="buying-second-col">
                <InputQuery
                  placeholder="Payee Code"
                  :isRequired="true"
                  :items="payeeCodeList"
                  :isDisabled="viewMode"
                  :itemKey="payeeCodeKey"
                  :descKey="payeeCodeDesc"
                  :selectedObject.sync="selectedPayeeCode"
                  :errorMessage.sync="payeeCodeError"
                />
              </div>
              <div class="foreign-currency-style" slot="buying-third-col"></div>
              <div class="foreign-currency-style" slot="selling-first-col"></div>
              <div slot="selling-second-col">
                <InputQuery
                  placeholder="Billing Customer"
                  :isRequired="true"
                  :items="billCustList"
                  :isDisabled="viewMode"
                  itemKey="Customer Code"
                  descKey="Customer Name"
                  :selectedObject.sync="selectedBillingCustomer"
                  :errorMessage.sync="billingCustomerError"
                />
              </div>
              <div slot="selling-third-col" class="foreign-currency-style"></div>
            </ForeignCurrency>
            <div class="buttons" style="align-self: self-end; margin-top: 5px">
              <button v-if="!viewMode || editSelling" class="save-button" @click="saveButton">Save</button>
              <button class="cancel-button" @click="cancelButton">Cancel</button>
            </div>
          </div>
        </div>
        <div
          v-if="selectedDC.length > 1 && updateDCArr"
          style="width: 100%; height: calc(100% - 20px); margin-left: 5px; border-radius: 5px"
        >
          <TableBox
            title="Default Charges"
            :tableData="selectedDC"
            style="height: calc(100% - 20px)"
            :hideColumns="['UOM Type', 'UOM Range', 'Payable', 'Date Updated', 'FAmount', 'SeqNo']"
          />
          <div class="buttons" style="align-self: self-end; display: flex; justify-content: flex-end; margin-top: 5px">
            <button v-if="!viewMode" class="save-button" @click="saveButton">Save</button>
            <button class="cancel-button" @click="cancelButton">Cancel</button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="openInputs" class="job-charges-main-right" :style="{ width: openInputs ? '300px' : '0' }">
      <div style="height: 100%; width: 100%; background-color: white; padding: 3px; overflow: auto">
        <div class="right-menu-home-container">
          <!-- show CARDS -->

          <!-- Services -->
          <BoxContainer style="margin-top: 12px" :title="`Service (${serviceList.length})`" :isCollapsible="true">
            <div class="pending-trips-box" :style="{ height: showService && serviceList.length > 0 ? '100%' : '26px' }">
              <div v-if="showService && serviceList.length == 0" class="no-pending-trips"> No Item</div>
              <!-- <div v-if="pendingTripsIsLoading" class="pending-trips-loading-text">Loading Services. . .</div> -->
              <div class="pending-trips-list">
                <div v-for="i in serviceList" :key="i.id" class="hms-trips-content">
                  <div style="width: 100%; padding: 5px; background-color: lightblue">
                    <div class="trips-row" style="width: 100%; display: flex; flex-direction: row">
                      <div style="width: 50px; margin-right: 12px">Services</div>
                      <div style="margin-right: 12px">:</div>
                      <div style="width: 100%">{{ i['Service'] }}</div>
                    </div>
                    <div class="trips-row" style="width: 100%; display: flex; flex-direction: row">
                      <div style="width: 50px; margin-right: 12px">Remarks</div>
                      <div style="margin-right: 12px">:</div>
                      <div style="width: 100%">{{ i['Remarks'] }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BoxContainer>
          <!-- AR -->
          <BoxContainer
            style="margin-top: 12px"
            :title="`AR Invoice/DN (${jobChargesDetails['ARList'].length})`"
            :isCollapsible="true"
            v-if="jobChargesDetails['ARList'].length > 0"
          >
            <div
              class="pending-trips-box"
              :style="{ height: showAR && jobChargesDetails['ARList'].length > 0 ? '100%' : '0px' }"
            >
              <div v-if="showAR && jobChargesDetails['ARList'].length == 0" class="no-pending-trips">
                No Service Charged</div
              >
              <!-- <div v-if="pendingTripsIsLoading" class="pending-trips-loading-text">Loading Services. . .</div> -->
              <div class="pending-trips-list">
                <div
                  v-for="(h, i) in jobChargesDetails['ARList']"
                  :key="i"
                  class="hms-trips-content"
                  style="background-color: lightblue"
                >
                  <div style="width: 100%; padding: 5px">
                    <div
                      v-for="(val, key) in h"
                      :key="key"
                      class="trips-row"
                      style="width: 100%; display: flex; flex-direction: row"
                    >
                      <div style="width: 60%; margin-right: 3px">{{ key }}</div>
                      <div style="margin-right: 3px">:</div>
                      <div style="width: 100%">{{ val }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BoxContainer>
          <!-- AP -->
          <BoxContainer
            style="margin-top: 12px"
            :title="`AP Invoice (${jobChargesDetails['APList'].length})`"
            :isCollapsible="true"
            v-if="jobChargesDetails['APList'].length > 0"
          >
            <div
              class="pending-trips-box"
              :style="{ height: showAP && jobChargesDetails['APList'].length > 0 ? '100%' : '0px' }"
            >
              <div v-if="showAP && jobChargesDetails['APList'].length == 0" class="no-pending-trips">
                No Service Charged</div
              >
              <!-- <div v-if="pendingTripsIsLoading" class="pending-trips-loading-text">Loading Services. . .</div> -->
              <div class="pending-trips-list">
                <div
                  v-for="(h, i) in jobChargesDetails['APList']"
                  :key="i"
                  class="hms-trips-content"
                  style="background-color: lightblue"
                >
                  <div style="width: 100%; padding: 5px">
                    <div
                      v-for="(val, key) in h"
                      :key="key"
                      class="trips-row"
                      style="width: 100%; display: flex; flex-direction: row"
                    >
                      <div style="width: 60%; margin-right: 3px">{{ key }}</div>
                      <div style="margin-right: 3px">:</div>
                      <div style="width: 100%">{{ val }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BoxContainer>
          <!-- Payment No -->
          <BoxContainer
            style="margin-top: 12px"
            :title="`Payment No (${jobChargesDetails['PVList'].length})`"
            :isCollapsible="true"
            v-if="jobChargesDetails['PVList'].length > 0"
          >
            <div
              class="pending-trips-box"
              :style="{ height: showPV && jobChargesDetails['PVList'].length > 0 ? '100%' : '0px' }"
            >
              <div v-if="showPV && jobChargesDetails['PVList'].length == 0" class="no-pending-trips">
                No Service Charged</div
              >
              <!-- <div v-if="pendingTripsIsLoading" class="pending-trips-loading-text">Loading Services. . .</div> -->
              <div class="pending-trips-list">
                <div
                  v-for="(h, i) in jobChargesDetails['PVList']"
                  :key="i"
                  class="hms-trips-content"
                  style="background-color: lightblue"
                >
                  <div style="width: 100%; padding: 5px">
                    <div
                      v-for="(val, key) in h"
                      :key="key"
                      class="trips-row"
                      style="width: 100%; display: flex; flex-direction: row"
                    >
                      <div style="width: 60%; margin-right: 3px">{{ key }}</div>
                      <div style="margin-right: 3px">:</div>
                      <div style="width: 100%">{{ val }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BoxContainer>
          <!-- Default Charges -->
          <BoxContainer style="margin-top: 12px" :title="`Default Charges`" :isCollapsible="true">
            <Dropdown
              placeholder="Quotation No"
              :items="quotationList"
              :isDisabled="viewMode || (action != 'N' && action != '')"
              itemKey="Quotation No"
              :selectedObject.sync="selectedQuotation"
              @selected="quotationSelected"
            />
            <div
              ><b>Validity: </b>
              <div
                >{{
                  selectedQuotation == null || selectedQuotation['Description'] == '' ?
                    '-'
                  : selectedQuotation['Description']
                }}
                {{
                  selectedQuotation == null || selectedQuotation['days'] == '0' ?
                    ''
                  : `(${selectedQuotation['days']}) days`
                }}</div
              >
            </div>
            <div
              ><b>Last Updated by: </b>
              <div
                >{{ selectedQuotation == null ? '-' : selectedQuotation['UserID'] }} on
                {{ selectedQuotation == null ? '-' : selectedQuotation['DateUpdated'] }}
              </div>
            </div>
            <div
              ><b>Remarks:</b>
              <div>{{
                selectedQuotation == null || selectedQuotation['remarks'] == '' ? '-' : selectedQuotation['remarks']
              }}</div>
            </div>
            <br />
            <div style="display: flex; justify-content: space-between; align-items: center">
              <CheckBoxV2
                title="Select Multiple"
                :isChecked.sync="selectMultiple"
                @checkBoxClicked="toggleSelect"
                :isDisabled="viewMode || (action != 'N' && action != '')"
              />
              <div>{{ defaultChargesList.length }} records</div>
            </div>
            <div
              class="pending-trips-box"
              :style="{ height: defaultChargesList.length > 0 ? '100%' : '26px' }"
              :class="{ 'disabled-section': action != 'N' && action != '' }"
            >
              <div v-if="defaultChargesList.length == 0" class="no-pending-trips" style="background-color: #96969633">
                No Items
              </div>
              <div class="pending-trips-list">
                <div
                  v-for="i in defaultChargesList"
                  :key="i.id"
                  class="dc-content"
                  @click="toggleSelect(i)"
                  :class="{ selected: selectedDC.includes(i) }"
                >
                  <div style="width: 100%; padding: 5px">
                    <div
                      class="trips-row"
                      style="width: 100%; display: flex; justify-content: space-between; align-items: center"
                    >
                      <div style="font-size: 12px"
                        ><b>{{ i['Charge Code'] }}:</b> {{ i['Description'] }}</div
                      >
                    </div>
                    <div
                      class="trips-row"
                      style="width: 100%; display: flex; justify-content: space-between; margin-top: 5px"
                    >
                      <div class="row-items"><b>Qty:</b> {{ i['Qty'] }}</div>
                      <div class="row-items"><b>UOM:</b> {{ i['UOM'] == '' ? '-' : i['UOM'] }}</div>
                      <div class="row-items"
                        ><b>{{ i['Currency'] }}:</b> {{ formatCurrDC(i) }}</div
                      >
                    </div>
                    <div class="trips-row" style="width: 100%; margin-top: 5px">
                      <div><b>Remarks:</b> {{ i['Item Remarks'] == '' ? '-' : i['Item Remarks'] }}</div>
                      <div v-if="i['expired'] === '1'" class="expired"> Expired on {{ i['End Valid Date'] }} </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </BoxContainer>
        </div>
      </div>
    </div>

    <!-- <PopupV2 :show="showDeletePopup" title="Job Charges Cancellation" @buttonClicked="deletePopupButtonClicked" :buttons="deletePopupButtons">
      <div>Do you want to cancel this job charges ? </div>
      <div></div>
      <div> Job No: {{ jobChargesDetails['jobNo'] }}</div>
      <div> Charges Code:  {{ selectedChargesCode ? selectedChargesCode['Income Code'] : '' }}</div>
      <div> Net Amount:  {{ jobChargesDetails['buying'] }}</div>
      <div></div>
    </PopupV2> -->

    <PopupV2
      class="copy-charges-popup-container"
      width="30%"
      height="22.5%"
      :show="showJobListPopup"
      title="Query Job No"
      @buttonClicked="copyPopupButtonClicked"
      :buttons="copyPopupButtons"
    >
      <div style="min-height: 15%; max-height: 5px; overflow: hidden">Please select a job to copy Job Charges. </div>
      <!-- <InputQuery style="width: 100%; padding-left: 10%; padding-right: 10%; padding-bottom: 5%;" placeholder="Job No." :isRequired="true" :items="jobNoList" itemKey="Job No" :errorMessage.sync="jobNoError" :selectedObject.sync="selectedJobToCopy"/> -->
      <!-- <div style="height:40%"/> -->
      <InputQuery
        style="width: 80%; margin: 0 50px; overflow: visible"
        placeholder="Job No."
        :isRequired="true"
        :items="copyJobNoListFiltered"
        itemKey="Job No"
        :selectedObject.sync="selectedJobToCopy"
        :errorMessage.sync="copyjobNoError"
      />
    </PopupV2>

    <PopupV2
      :show="showChargesTableListPopup"
      title="Query Job No"
      @buttonClicked="copyChargesPopupButtonClicked"
      :buttons="copyPopupButtons"
      width="90%"
      height="90%"
    >
      <div style="height: fit-content; overflow: initial">Please select Job Charges. </div>
      <TableBox
        title="Job Charges"
        style="height: calc(100% - 18px); width: 100%; padding: 3px; overflow: auto"
        :maxSelection="-1"
        :tableData="selectedJobsListToCopy"
        :selectedRow.sync="selectedJobsToCopy"
        :hideColumns="['PV', 'PVAP', 'TxnID', 'APInvoice', 'ARInvoice']"
      />
    </PopupV2>

    <PopupV2
      :show="showDeletePopup"
      title="Job Charges Cancellation"
      @buttonClicked="deleteClicked"
      :buttons="deletePopupButtons"
    >
      <div> Do you want to cancel this job charge ? </div>
      <div> Job No: {{ jobChargesDetails['jobNo'] }}</div>
      <div> Charges Code: {{ selectedChargesCode ? selectedChargesCode['Income Code'] : '' }}</div>
      <div> Net Amount: {{ jobChargesDetails['buying'] }}</div>
      <Input
        placeholder="Delete Remarks"
        :inputValue.sync="deleteRemarks"
        :errorMessage.sync="deleteRemarksError"
        :isRequired="true"
      />
    </PopupV2>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  components: {},
  data: function () {
    return {
      //#region DATA
      mountedPromises: [],
      mountedPromisesFulfilledCount: 0,

      leftMenuWidth: 0,
      mainSectionwidth: 0,
      rightSectionwidth: 0,
      boxesSectionHeight: 0,
      openInputs: false,
      menu: [
        {
          title: 'New Job Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          visible: true,
          key: 'mnuNewJobCharges',
        },
        {
          title: 'Edit Job Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          visible: true,
          key: 'cmdEdit',
        },
        {
          title: 'Delete Job Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          visible: true,
          key: 'cmdDelete',
        },
        {
          title: 'View Job Charges',
          icon: 'https://dsmapi.logistics.systems/dsm6gicons/icons8-view-64.png',
          enabled: false,
          visible: true,
          key: '',
        },
        {
          title: 'Copy Charges from Other Job',
          icon: 'https://dsmlib.logistics.systems/Icons/copy-80px.png',
          enabled: false,
          visible: true,
          key: 'mnuCopy',
        },
        {
          title: 'Hide Cancelled Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/hide-file.png',
          enabled: false,
          visible: true,
        },
        {
          title: 'View Job Charges by Cont. No',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          visible: true,
        },
        {
          title: 'Refresh',
          icon: 'https://dsmlib.logistics.systems/Icons/RefreshOutline.png',
          enabled: false,
          visible: true,
        },
        // { title: 'View Job Charges Details', icon: 'https://dsmlib.logistics.systems/Icons/Save.png', enabled: true },
        {
          title: 'Update Job Complete',
          icon: 'https://dsmlib.logistics.systems/Icons/Save.png',
          enabled: false,
          visible: false,
          key: 'cmdCloseJob',
        },
        {
          title: 'Print Job Charges',
          icon: 'https://dsmlib.logistics.systems/Icons/Print.png',
          enabled: false,
          visible: true,
          key: 'mnuPrintJobChargesList',
        },
        {
          title: 'Update Selling',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          visible: true,
          key: 'cmdEdit',
        },
      ],
      tablemenu: [
        {
          title: 'Job Charges by Job No. & Container No.',
          icon: 'https://dsmlib.logistics.systems/Icons/Job.png',
          enabled: true,
        },
        { title: 'Services', icon: 'https://dsmlib.logistics.systems/Icons/service.png', enabled: true },
        { title: 'AR Invoice/DN', icon: 'https://dsmlib.logistics.systems/Icons/AR.png', enabled: true },
        { title: 'AP Invoice', icon: 'https://dsmlib.logistics.systems/Icons/AP.png', enabled: true },
        { title: 'Payment No', icon: 'https://dsmlib.logistics.systems/Icons/PV.png', enabled: true },
      ],
      resizeObserver: null,
      tableSelected: false,
      isSelect: false,
      isJobEmpty: true,
      loading: false,
      noOfRows: '',
      loadText: '',
      jobChargesList: [],
      tableListToggle: [],
      tableDataType: {},
      tableListToggleDataType: {},
      selectedTableListToggle: [],
      myTextAlign: 'right',
      viewMode: false,
      viewModePK: false,
      editSelling: false,
      deletePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      copyPopupButtons: [{ text: 'OK' }, { text: 'Cancel' }],
      adjustmentType: [
        { item: 1, AdjstType: 'Adjustment' },
        { item: 2, AdjstType: 'Rebate' },
      ],
      queryBy: [
        // {item: 1, query: "Job No" },
        // {item: 2, query : "Project No"}
      ],
      payeeTypeList: [],
      selectedPayeeType: null,
      selectedPayeeCode: null,
      billingCustomerError: '',
      selectedBillingCustomer: null,
      defaultBillingCustomer: null, //default billing customer from job
      payeeTypeError: '',
      payeeCodeError: '',

      // quotation
      selectedQuotation: null,
      defaultChargesList: [],
      selectedDC: [], // Stores the selected items
      selectMultiple: false,
      updateDCArr: false,

      payableChecking: '',
      selectedQuery: null,
      prePopulate: false,
      preJob: '',
      legend: [],
      getCostingAnalysisSumByJobData: {
        amtBilledExclTax: 0,
        tax: 0,
        costExclTax: 0,
        grossProfit: 0,
        gProfitMargin: 0,
      },
      jobStatusIndicator: -1,

      showJobCharges: true,
      showSummary: true,
      showService: true,
      showAP: true,
      showPV: true,
      showAR: true,
      showDeletePopup: false,
      showJobListPopup: false,
      showDeletePopupWithRemarks: false,
      deleteRemarks: '',
      deleteRemarksError: '',
      isNewJobCharges: false,
      showChargesTableListPopup: false,
      jobSummaryList: [],
      accruedRev: 0,
      accruedRevForeign: 0,
      sellingFCurr: '',
      sellingMultiCurr: false,
      accruedExpenses: 0,
      accruedExpensesForeign: 0,
      buyingFCurr: '',
      buyingMultiCurr: false,
      selectedJobCharges: [],
      action: '',
      settingsitem: '',
      enableVendorRebate: '',
      showJobDetails: true,
      jobNoList: [],
      copyJobNoListFiltered: [],
      selectedJob: null,
      selectedJobToCopy: null,
      selectedJobsToCopy: [],
      selectedJobsListToCopy: [],
      projectNoList: [],
      selectedProject: null,
      customerList: [],
      containerList: [],
      consignmentlist: [],
      payeeTypeList: [],
      payeeCodeList: [],
      billCustList: [],
      quotationList: [],
      payeeCodeKey: '',
      payeeCodeDesc: '',
      billingCustomerList: [],
      costCodeList: [],
      chargeCodeList: [],
      empEditIndex: -1,
      jobChargesList: [],
      deletedJobChargesList: [],
      jobSummaryListTableDataType: [],
      serviceList: [],
      totalBuying: 0,
      totalFBuying: 0,
      totalMarkup: 0,
      totalFMarkup: 0,
      totalSelling: 0,
      totalFSelling: 0,
      jobno: '',
      freeTextJobProjNo: '',
      validJobNo: false,
      jobNoLoad: true,
      projectno: '',
      entryRequired: [],
      oldSelectedJobCharges: [],
      oldTxnID: '',
      jobNoError: '',
      copyjobNoError: '',
      projectNoError: '',
      chargesCodeError: '',
      selectedCN: null,
      selectedCont: null,
      selectedChargesCode: null,
      jobChargesDetails: {
        jobNo: null,
        projectNo: null,
        chargesCode: null,
        container: null,
        consignment: null,
        buying: '',
        buyTotal: '',
        markup: '',
        markTotal: '',
        selling: '',
        sellTotal: '',
        docRefNo: '',
        docType: '',
        costCode: null,
        vendorRebate: '',
        remark: '',
        userID: '',
        dateUpdate: '',
        expenseItem: '',
        APInvoice: '',
        ARInv: '',
        paymentNo: '',
        AdjType: null,
        indicator: '',
        chqNo: '',
        APList: [],
        ARList: [],
        PVList: [],
        PVListtemp: [],
        customer: null,
        txnid: '',
        type: '',
      },
      foreignDetails: {
        quantity: '1', //qty
        uom: '', //UOM
        buying: {
          currency: '', //currencyBuying
          unitPrice: '', //fbuying
          totalPrice: '', //fbuyTotal
          exchRate: '', // buyRate
        },
        markup: {
          unitPrice: '', // fmarkup
          totalPrice: '', // fmarkTotal
        },
        selling: {
          currency: '', // currencySelling
          unitPrice: '', // fselling
          totalPrice: '', // fsellTotal
          exchRate: '', // sellRate
        },
        myrEquivalent: {
          buyingUnitPrice: '',
          buyingTotalPrice: '',
          markupUnitPrice: '',
          markupTotalPrice: '',
          sellingUnitPrice: '',
          sellingTotalPrice: '',
        },
      },
      //#endregion
    };
  },
  props: {},
  methods: {
    async sasControlFunction() {
      this.$fullscreenLoading('Checking Security Access');
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FINPayment&page=Job Charges`);

      this.menu.forEach((m) => {
        m.enabled = true;
        m.oriEnabled = true; //have this oriEnabled because some function will need to enable or disable the menu so have to use another key so that it wont enable any menu button that is suppose to be disable
      });

      sasControl.forEach((k) => {
        //key in menu same as control value from api
        const selectedMenu = this.menu.filter((m) => m['key'] == k['Control']); //special case uses filter because got more than 1 menu uses same key
        if (selectedMenu.length > 0) {
          selectedMenu.forEach((selectedMenu) => {
            selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
            selectedMenu['oriEnabled'] = selectedMenu['enabled'];
          });
        }
      });

      this.$fullscreenLoading('');
    },
    menuClicked: async function (item) {
      switch (item.title) {
        case 'New Job Charges':
          if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
            this.$showAlert('error', 'No Job is Selected', 'Please select a job first!'); // add "/Project" after we enable the function to query by Project.
            this.jobNoError = 'No Job is Selected';
            return;
          }

          //check if job no is valid
          if (!this.validJobNo) {
            this.$showAlert('error', 'Invalid Job No', 'Please select a valid Job No!');
            return;
          }

          this.action = 'N';
          this.payableChecking = '';
          this.openInputs = true;
          this.clearAllField();
          this.addJobCharges();
          this.selectedBillingCustomer = this.billCustList.find((i) => {
            return i['Customer Code'] == this.defaultBillingCustomer;
          });
          this.viewModePK = true;
          //if there is only 1 quotation, auto select it
          //else clear the default if is empty or multiple
          if (this.quotationList.length == 1) {
            this.selectedQuotation = this.quotationList[0];
            this.quotationSelected(this.selectedQuotation);
          } else {
            this.defaultChargesList = [];
            this.selectedQuotation = null;
          }
          break;
        case 'Edit Job Charges':
          this.action = 'E';
          if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
            this.$showAlert('error', 'No Job is Selected', 'Please select a job first!'); // add "/Project" after we enable the function to query by Project.
            this.jobNoError = 'No Job is Selected';
            return;
          }

          if ((await this.editChecking('Edit Job Charges')) == false) {
            return; //straight return since editChecking already show error popup
          }

          this.openInputs = true;
          this.editJobCharges();
          this.viewModePK = true;
          if (this.quotationList.length == 1) {
            this.selectedQuotation = this.quotationList[0];
            this.quotationSelected(this.selectedQuotation);
          } else {
            this.defaultChargesList = [];
            this.selectedQuotation = null;
          }
          break;
        case 'View Job Charges':
          this.action = 'V';
          if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
            this.$showAlert('error', 'No Job is Selected', 'Please select a job first!'); // add "/Project" after we enable the function to query by Project.
            this.jobNoError = 'No Job is Selected';
            return;
          }
          if (this.selectedTableListToggle.length == 0) {
            this.$showAlert('error', 'No Job Charges Selected', 'Please select a job charges first!');
          } else {
            this.openInputs = true;
            this.viewMode = true;
            this.populateDetails(this.selectedTableListToggle[0]);
            if (this.quotationList.length == 1) {
              this.selectedQuotation = this.quotationList[0];
              this.quotationSelected(this.selectedQuotation);
            } else {
              this.defaultChargesList = [];
              this.selectedQuotation = null;
            }
          }
          break;
        case 'Delete Job Charges':
          this.action = 'D';
          if (this.selectedTableListToggle.length == 0) {
            this.$showAlert('error', 'No Job Charges Selected', 'Please select a job charges first!');
            return;
          }
          if (
            this.selectedTableListToggle.length != 0 &&
            (this.selectedTableListToggle[0]['Billed'].includes('Billed') ||
              this.selectedTableListToggle[0]['Paid'].includes('Paid'))
          ) {
            this.$showAlert('error', 'Cannot Delete!', 'Cannot delete charges that have make payment!');
            return;
          }
          this.deleteJobCharges();
          break;
        case 'Hide Cancelled Charges':
          if ((this.selectedJob || this.freeTextJobProjNo) && this.jobno) {
            this.jobChargesList = [];
            this.menu[5]['title'] = 'Show Cancelled Charges';
            this.menu[5]['icon'] = 'https://dsmlib.logistics.systems/Icons/GenericFile.png';
            this.getJobCharges('hide');
          } else {
            this.$showAlert('warning', 'No Job selected', 'Please select a job first!');
            this.jobNoError = 'No Job is Selected';
          }
          break;
        case 'Show Cancelled Charges':
          if (this.selectedJob || this.freeTextJobProjNo) {
            this.jobChargesList = [];
            this.menu[5]['title'] = 'Hide Cancelled Charges';
            this.menu[5]['icon'] = 'https://dsmlib.logistics.systems/Icons/hide-file.png';
            this.getJobCharges();
          } else {
            this.$showAlert('warning', 'No Job selected', 'Please select a job first!');
            this.jobNoError = 'No Job is Selected';
          }
          break;
        case 'View Job Charges by Cont. No':
          if (this.selectedJob || this.freeTextJobProjNo) {
            this.tableListToggle = [];
            this.tableListToggleDataType = {};
            this.selectedTableListToggle = [];
            this.$nextTick(() => {
              this.jobSummaryList.forEach((c) => this.tableListToggle.push(c));
              this.tableListToggleDataType = this.jobSummaryListTableDataType;
              this.selectedTableListToggle = this.selectedJobCharges;
            });
            this.menu[6]['title'] = 'View All Job Charges';
            this.menu[6]['icon'] = 'https://dsmlib.logistics.systems/Icons/GenericFile.png';
            if (this.action != 'N') {
              this.menu[5]['enabled'] = false;
              this.menu[3]['enabled'] = false;
              this.menu[1]['enabled'] = false;
              this.menu[2]['enabled'] = false;
            }
            // this.getJobCharges(null);
          } else {
            this.$showAlert('warning', 'No Job selected', 'Please select a job first!');
            this.jobNoError = 'No Job is Selected';
          }
          break;
        case 'View All Job Charges':
          if (this.selectedJob || this.freeTextJobProjNo) {
            this.tableListToggle = [];
            this.tableListToggleDataType = {};
            this.selectedTableListToggle = [];
            this.$nextTick(() => {
              this.jobChargesList.forEach((c) => this.tableListToggle.push(c));
              this.tableListToggleDataType = this.tableDataType;
              this.selectedTableListToggle = this.selectedJobCharges;
            });
            if (this.action != 'N') {
              this.menu[5]['enabled'] = this.menu[5]['oriEnabled'] == false ? false : true;
              this.menu[3]['enabled'] = this.menu[3]['oriEnabled'] == false ? false : true;
              this.menu[1]['enabled'] = this.menu[1]['oriEnabled'] == false ? false : true;
              this.menu[2]['enabled'] = this.menu[2]['oriEnabled'] == false ? false : true;
            }
            this.menu[6]['title'] = 'View Job Charges by Cont. No';
            this.menu[6]['icon'] = 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png';
            // this.getJobCharges(null);
          } else {
            this.$showAlert('warning', 'No Job selected', 'Please select a job first!');
            this.jobNoError = 'No Job is Selected';
          }
          break;
        case 'Refresh':
          this.tableListToggle = [];
          this.selectedTableListToggle = [];
          if (!this.selectedJob && !this.freeTextJobProjNo) {
            this.$showAlert('warning', 'No Job selected', 'Please select a job first!');
            this.jobNoError = 'No Job is Selected';
            return;
          }
          this.menu[6]['title'] = 'View Job Charges by Cont. No';
          this.menu[6]['icon'] = 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png';
          this.getJobCharges();
          this.menu.forEach((m) => (m['enabled'] = true));
          break;
        case 'Update Job Complete':
          if (!this.selectedJob && !this.freeTextJobProjNo) {
            this.$showAlert('error', 'No Job selected', 'Please select a job first!');
            this.jobNoError = 'No Job is Selected';
            return;
          }
          let dataToPost = {
            finish: '1',
            jobno: this.jobno,
            status: '12002',
          };
          let result = await this.$apiCallV2(`/JobCharges/UpdateJobComplete`, dataToPost);
          if (result[0]['Results'] == 0) {
            this.showChargesTableListPopup = false;
            this.jobChargesList = [];
            this.getJobCharges();
            this.$showAlert('success', 'Success', 'Successfully Updated Job Complete.');
          } else {
            if (result[0]['ErrMsg'].includes('Job Complete status already updated!')) {
              let parts = result[0]['ErrMsg'].split('!');
              if (parts.length > 1) {
                let afterExclamationMark = parts[1].trim();
                this.$showAlert('info', 'Job Complete status already updated!', afterExclamationMark);
              }
            } else {
              this.$showAlert('error', 'An Error has occurred', result[0]['ErrMsg']);
            }
          }

          // break;
          break;
        case 'Copy Charges from Other Job':
          // this.jobChargesList = [];
          this.action = '';
          this.selectedJobToCopy = null;
          this.selectedJobsToCopy = [];
          if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
            this.$showAlert('error', 'No Job is Selected', 'Please select a job first!'); // add "/Project" after we enable the function to query by Project.
            this.jobNoError = 'No Job is Selected';
          } else {
            this.copyJobNoListFiltered = this.jobNoList.filter((job) => {
              return job['Job No'] != this.jobno;
            });
            this.showJobListPopup = true;
          }
          break;
        case `Print Job Charges`:
          var printDocumentURL = '';
          const path = this.$route.fullPath;
          if (path.includes('FINAR')) printDocumentURL = `/Home/${this.$route.params.user}/FINAR/Print Job Charges`;
          else if (path.includes('FINPayment'))
            printDocumentURL = `/Home/${this.$route.params.user}/FINPayment/Print Job Charges`;

          if (this.selectedJob && this.jobChargesList.length < 1) {
            let confirm = await this.$showAlert(
              'warning',
              'No Job Charges Created',
              'Are you sure you want to print job charges list without job charges?',
              [{ text: 'Yes' }, { text: 'No', textColor: 'white', color: 'gray' }],
            );

            if (confirm === 'No') {
              return;
            }
          }

          if (this.selectedJob) printDocumentURL += `?jobno=${this.selectedJob['Job No'] ?? ''}`;

          const resolvedPrintDocumentRoute = this.$router.resolve(printDocumentURL);
          window.open(resolvedPrintDocumentRoute.href, '_blank'); // open in a new tab
          break;
        case 'Update Selling':
          this.action = 'E';
          if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
            this.$showAlert('error', 'No Job is Selected', 'Please select a job first!'); // add "/Project" after we enable the function to query by Project.
            this.jobNoError = 'No Job is Selected';
            return;
          } else if (this.selectedTableListToggle.length == 0) {
            this.$showAlert('error', 'No Job Charges Selected', 'Please select a job charges first!');
            return;
          }

          if ((await this.editChecking('Update Selling')) == false) {
            return; //straight return since function already show error popup
          }

          this.openInputs = true;
          this.editJobCharges();
          this.viewModePK = true;
          this.editSelling = true;
          this.viewMode = true;
          if (this.quotationList.length == 1) {
            this.selectedQuotation = this.quotationList[0];
            this.quotationSelected(this.selectedQuotation);
          } else {
            this.defaultChargesList = [];
            this.selectedQuotation = null;
          }

          break;
      }
    },
    bottomMenuClicked: function (item) {
      switch (item.title) {
        case 'Job Charges by Job No. & Container No.':
          if (this.showSummary) this.showSummary = false;
          else this.showSummary = true;
          break;
        case 'Services':
          if (this.showService) this.showService = false;
          else this.showService = true;
          break;
        case 'AP Invoice':
          if (this.showAP) this.showAP = false;
          else this.showAP = true;
          break;
        case 'AR Invoice/DN':
          if (this.showAR) this.showAR = false;
          else this.showAR = true;
          break;
        case 'Payment No':
          if (this.showPV) this.showPV = false;
          else this.showPV = true;
          break;
      }
    },
    clearAllField: function () {
      this.viewModePK = false;
      // this.jobSummaryList = [];
      this.jobChargesDetails['jobNo'] = null;
      this.jobChargesDetails['projectNo'] = null;
      this.jobChargesDetails['container'] = null;
      this.selectedCont = null;
      this.selectedChargesCode = null;
      this.jobChargesDetails['consignment'] = null;
      this.selectedCN = null;
      this.jobChargesDetails['buying'] = '';
      this.jobChargesDetails['buyTotal'] = '';
      this.jobChargesDetails['markup'] = '';
      this.jobChargesDetails['markTotal'] = '';
      this.jobChargesDetails['selling'] = '';
      this.jobChargesDetails['sellTotal'] = '';
      this.jobChargesDetails['docRefNo'] = '';
      this.jobChargesDetails['docType'] = '';
      this.jobChargesDetails['costCode'] = null;
      this.jobChargesDetails['costCode'] = null;
      this.jobChargesDetails['vendorRebate'] = '';
      this.jobChargesDetails['remark'] = '';
      this.jobChargesDetails['userID'] = '';
      this.jobChargesDetails['dateUpdate'] = '';
      this.jobChargesDetails['expenseItem'] = '';
      this.jobChargesDetails['APInvoice'] = '';
      this.jobChargesDetails['ARInv'] = '';
      this.jobChargesDetails['paymentNo'] = '';
      this.jobChargesDetails['chqNo'] = '';
      this.jobChargesDetails['pv'] = null;
      this.jobChargesDetails['indicator'] = '';
      this.jobChargesDetails['AdjType'] = null;
      this.billingCustomer = null;
      this.payeeCodeList = [];
      this.selectedBillingCustomer = null;
      this.selectedPayeeType = null;
      this.selectedPayeeCode = null;
      this.selectedDC = [];
      this.selectMultiple = false;
      this.foreignDetails = {
        quantity: '1',
        uom: null,
        buying: {
          currency: null,
          unitPrice: '',
          totalPrice: 0,
          exchRate: 0,
        },
        markup: {
          unitPrice: '',
          totalPrice: '',
        },
        selling: {
          currency: null,
          unitPrice: '',
          totalPrice: '',
          exchRate: '',
        },
      };
      this.clearError();
    },
    clearError: function () {
      this.jobNoError = '';
      this.copyjobNoError = '';
      this.projectNoError = '';
      this.chargesCodeError = '';
      this.deleteRemarksError = '';
      this.billingCustomerError = '';
      this.payeeTypeError = '';
      this.payeeCodeError = '';
    },
    populateDetails: function (jobDetails) {
      this.clearAllField();
      this.jobChargesDetails['jobNo'] = !jobDetails['Job No'] ? '' : jobDetails['Job No'];
      this.jobChargesDetails['projectNo'] = !jobDetails['Project No'] ? '' : jobDetails['Project No'];
      this.selectedChargesCode =
        !jobDetails['Charges Code'] ? null : (
          this.chargeCodeList.find((i) => {
            return i['Income Code'] == jobDetails['Charges Code'];
          })
        );
      this.selectedCont =
        !jobDetails['Container #'] ? null : (
          this.containerList.find((i) => {
            return i['Cont No'] == jobDetails['Container #'];
          })
        );
      this.selectedCN =
        !jobDetails['Consignment #'] ? null : (
          this.consignmentlist.find((i) => {
            return i['Consignment No'] == jobDetails['Consignment #'];
          })
        );
      this.jobChargesDetails['buying'] = !jobDetails['Buying'] ? '' : jobDetails['Buying'];
      this.jobChargesDetails['markup'] = !jobDetails['Mark Up'] ? '' : jobDetails['Mark Up'];
      this.jobChargesDetails['selling'] = !jobDetails['Selling'] ? '' : jobDetails['Selling'];
      this.jobChargesDetails['docRefNo'] = !jobDetails['Doc Ref No'] ? '' : jobDetails['Doc Ref No'];
      this.jobChargesDetails['docType'] = !jobDetails['Doc Type'] ? '' : jobDetails['Doc Type'];
      this.jobChargesDetails['costCode'] = this.costCodeList.find((i) => {
        return i['Cost Code'] == jobDetails['Cost Code'];
      });

      this.jobChargesDetails['vendorRebate'] = !jobDetails['Vendor Rebate'] ? '' : jobDetails['Vendor Rebate'];
      this.jobChargesDetails['remark'] = !jobDetails['Remark'] ? '' : jobDetails['Remark'];
      this.jobChargesDetails['userID'] = !jobDetails['UserID'] ? '' : jobDetails['UserID'];
      this.jobChargesDetails['dateUpdate'] = !jobDetails['Date Update'] ? '' : jobDetails['Date Update'];
      // jobChargesDetails['indicator'] == 'Y' ? 'Is Expense' : 'Is Not Expense'
      this.jobChargesDetails['expenseItem'] = !jobDetails['Expense Item'] ? 'Is Not Expense' : 'Is Expense';
      this.jobChargesDetails['txnid'] = !jobDetails['TxnID'] ? '' : jobDetails['TxnID'];
      this.jobChargesDetails['indicator'] = !jobDetails['Indicator'] ? '' : jobDetails['Indicator'];
      this.jobChargesDetails['AdjType'] =
        !jobDetails['AdjType'] ? null
        : jobDetails['AdjType'] == 'A' ?
          this.adjustmentType.find((i) => {
            return i['AdjstType'] == 'Adjustment';
          })
        : this.adjustmentType.find((i) => {
            return i['AdjstType'] == 'Rebate';
          });

      let tempAPInvoice = !jobDetails['APInvoice'] ? [] : jobDetails['APInvoice'];
      if (tempAPInvoice.length > 0)
        tempAPInvoice.forEach((AP) => {
          delete AP.APRef;
        });
      this.jobChargesDetails['APList'] = tempAPInvoice;

      let tempARInvoice = !jobDetails['ARInvoice'] ? [] : jobDetails['ARInvoice'];
      if (tempARInvoice.length > 0)
        tempARInvoice.forEach((AR) => {
          delete AR.ARRef;
        });
      this.jobChargesDetails['ARList'] = tempARInvoice;

      let tempPV = !jobDetails['PV'] ? [] : jobDetails['PV'];
      if (tempPV.length > 0)
        tempPV.forEach((PV) => {
          delete PV.PVRef;
        });
      this.jobChargesDetails['PVList'] = tempPV;
      let markupUP = !jobDetails['F.Mark Up'] ? 0 : jobDetails['F.Mark Up'] / jobDetails['Qty'];
      this.selectedPayeeType = this.payeeTypeList.find((i) => {
        return i['Party Code'] == jobDetails['Payee Type'];
      });

      if (this.selectedPayeeType) {
        this.payeeTypeSelected(this.selectedPayeeType, jobDetails['Payee Code']);
      }
      this.selectedBillingCustomer = this.billCustList.find((i) => {
        return i['Customer Code'] == jobDetails['Billing Customer'];
      });
      this.foreignDetails = {
        quantity: !jobDetails['Qty'] ? '1' : jobDetails['Qty'],
        uom: jobDetails['UOM'] ? jobDetails['UOM'] : '',
        buying: {
          currency: jobDetails['Buying Currency'] ? jobDetails['Buying Currency'] : '',
          unitPrice: '',
          totalPrice: !jobDetails['F.Buying'] ? 0 : jobDetails['F.Buying'],
          exchRate: !jobDetails['Buying Rate'] ? 0 : jobDetails['Buying Rate'],
        },
        markup: {
          unitPrice: Number(markupUP).toFixed(4),
          totalPrice: !jobDetails['F.Mark Up'] ? '' : jobDetails['F.Mark Up'],
        },
        selling: {
          currency: jobDetails['Currency'] ? jobDetails['Currency'] : '',
          unitPrice: '',
          totalPrice: !jobDetails['F.Selling'] ? '' : jobDetails['F.Selling'],
          exchRate: !jobDetails['Rate'] ? '' : jobDetails['Rate'],
        },
      };
    },
    payeeTypeSelected: async function (e, code) {
      this.$fullscreenLoading('Getting Payee Code');
      this.payeeCodeList =
        e ? await this.$apiCallV2('/Master/GetDetailsMaster', { masterfile: 'payeecode', recordid: e['Table'] }) : [];
      // this.selectedPayeeCode = null;
      if (this.payeeCodeList.length > 0) {
        let codeKeys = Object.keys(this.payeeCodeList[0]);
        this.payeeCodeKey = codeKeys[0];
        this.payeeCodeDesc = codeKeys[1];
      }
      this.selectedPayeeCode = this.payeeCodeList.find((i) => {
        return i[this.payeeCodeKey] == code;
      });
      this.selectedPayeeType = e;
      this.$fullscreenLoading();
    },
    quotationSelected: async function (quotation) {
      if (quotation) {
        const response = await this.$apiCallV2(`/JobCharges/GetDefaultCharges`, {
          quotationno: quotation['Quotation No'],
          orderexpired: 'Y',
        });
        this.defaultChargesList = response[0]['DefaultChargesList'];
      }
    },
    toggleSelect: async function (item) {
      this.updateDCArr = false;
      if (item && item['expired'] == '1' && !this.selectedDC.includes(item)) {
        let confirm = await this.$showAlert(
          'warning',
          'Expired Charges',
          'Are you sure you want add expired charges?',
          [{ text: 'Add' }, { text: 'Cancel', textColor: 'white', color: 'gray' }],
        );

        //re-render the table else will be empty
        if (confirm === 'Cancel') {
          this.$nextTick(() => {
            this.updateDCArr = true;
          });
          return;
        }
      }

      //if the item is already selected, remove it when selected again
      if (this.selectedDC.includes(item)) {
        this.selectedDC = this.selectedDC.filter((selectedDC) => selectedDC !== item);
      } else {
        //checkbox (this.selectedMultiple) is checked/unchecked is a boolean that will be inserted together into the array
        //only insert if the item is not a boolean to prevent error rendering the tablebox which is expecting an object
        if (typeof item !== 'boolean') this.selectedDC = this.selectMultiple ? [...this.selectedDC, item] : [item];
      }

      this.$nextTick(() => {
        this.updateDCArr = true;
      });
      this.selectedDC = this.selectedDC.filter((item) => item !== undefined);
      this.clearError();

      this.selectedChargesCode =
        this.selectedDC[0]?.['Charge Code'] ?
          this.chargeCodeList.find((i) => {
            return i['Income Code'] == this.selectedDC[0]?.['Charge Code'];
          })
        : null;
      this.jobChargesDetails['remark'] = this.selectedDC[0]?.['Item Remarks'] ?? '';
      this.selectedPayeeType =
        this.payeeTypeList.find((i) => {
          return i['Party Code'] == this.selectedDC[0]?.['Payee Type'];
        }) ?? null;
      this.payeeTypeSelected(this.selectedPayeeType, this.selectedDC[0]?.['Payee Code']);
      this.selectedBillingCustomer = this.billCustList.find((i) => {
        return i['Customer Code'] == this.quotationList[0]['billTo'];
      });
      if (this.selectedDC.length < 1) {
        this.selectedBillingCustomer = null;
      }
      this.foreignDetails = {
        quantity: this.selectedDC[0]?.['Qty'] ?? '1',
        uom: this.selectedDC[0]?.['UOM'] ?? '',
        buying: {
          currency: this.selectedDC[0]?.['Currency'] ?? '',
          unitPrice: '',
          totalPrice: this.selectedDC[0]?.['Buying'] ?? 0,
          exchRate: this.selectedDC[0]?.['Currency'] ? '1' : '',
        },
        markup: {
          unitPrice: '',
          totalPrice: '',
        },
        selling: {
          currency: this.selectedDC[0]?.['Currency'] ?? '',
          unitPrice: '',
          totalPrice: this.selectedDC[0]?.['Selling'] ?? 0,
          exchRate: this.selectedDC[0]?.['Currency'] ? '1' : '',
        },
      };
    },
    addJobCharges: function () {
      this.viewMode = false;
      this.jobNoError = '';
      this.projectNoError = '';
      this.chargesCodeError = '';
      this.selectedTableListToggle = [];
      this.clearAllField();
      this.jobChargesDetails['AdjType'] = { item: 1, AdjstType: 'Adjustment' };
    },
    editJobCharges: function () {
      this.viewMode = false;
      this.populateEditJobCharges(this.selectedTableListToggle[0]);
    },
    populateEditJobCharges: function (jobDetails) {
      this.jobChargesDetails['jobNo'] = !jobDetails['Job No'] ? '' : jobDetails['Job No'];
      this.jobChargesDetails['projectNo'] = !jobDetails['Project No'] ? '' : jobDetails['Project No'];
      this.selectedChargesCode =
        !jobDetails['Charges Code'] ? null : (
          this.chargeCodeList.find((i) => {
            return i['Income Code'] == jobDetails['Charges Code'];
          })
        );
      this.selectedCont =
        !jobDetails['Container #'] ? null : (
          this.containerList.find((i) => {
            return i['Cont No'] == jobDetails['Container #'];
          })
        );
      this.selectedCN =
        !jobDetails['Consignment #'] ? null : (
          this.consignmentlist.find((i) => {
            return i['Consignment No'] == jobDetails['Consignment #'];
          })
        );
      this.jobChargesDetails['buying'] = !jobDetails['Buying'] ? 0 : jobDetails['Buying'];
      this.jobChargesDetails['markup'] = !jobDetails['Mark Up'] ? '' : jobDetails['Mark Up'];
      this.jobChargesDetails['selling'] = !jobDetails['Selling'] ? '' : jobDetails['Selling'];
      this.jobChargesDetails['docRefNo'] = !jobDetails['Doc Ref No'] ? '' : jobDetails['Doc Ref No'];
      this.jobChargesDetails['docType'] = !jobDetails['Doc Type'] ? '' : jobDetails['Doc Type'];
      this.jobChargesDetails['costCode'] = this.costCodeList.find((i) => {
        return i['Cost Code'] == jobDetails['Cost Code'];
      });

      this.jobChargesDetails['vendorRebate'] = !jobDetails['Vendor Rebate'] ? '' : jobDetails['Vendor Rebate'];
      this.jobChargesDetails['remark'] = !jobDetails['Remark'] ? '' : jobDetails['Remark'];
      this.jobChargesDetails['userID'] = !jobDetails['UserID'] ? '' : jobDetails['UserID'];
      this.jobChargesDetails['dateUpdate'] = !jobDetails['Date Update'] ? '' : jobDetails['Date Update'];
      this.jobChargesDetails['expenseItem'] = !jobDetails['Expense Item'] ? 'Is Not Expense' : 'Is Expense';
      this.jobChargesDetails['txnid'] = !jobDetails['TxnID'] ? '' : jobDetails['TxnID'];
      this.jobChargesDetails['indicator'] = !jobDetails['Indicator'] ? '' : jobDetails['Indicator'];
      this.jobChargesDetails['AdjType'] =
        !jobDetails['AdjType'] ? null
        : jobDetails['AdjType'] == 'A' ?
          this.adjustmentType.find((i) => {
            return i['AdjstType'] == 'Adjustment';
          })
        : this.adjustmentType.find((i) => {
            return i['AdjstType'] == 'Rebate';
          });
      let markupUP = !jobDetails['F.Mark Up'] ? 0 : jobDetails['F.Mark Up'] / jobDetails['Qty'];
      this.selectedPayeeType = this.payeeTypeList.find((i) => {
        return i['Party Code'] == jobDetails['Payee Type'];
      });
      if (this.selectedPayeeType) {
        this.payeeTypeSelected(this.selectedPayeeType, jobDetails['Payee Code']);
      }
      this.selectedBillingCustomer = this.billCustList.find((i) => {
        return i['Customer Code'] == jobDetails['Billing Customer'];
      });
      this.foreignDetails = {
        quantity: !jobDetails['Qty'] ? '1' : jobDetails['Qty'],
        uom: jobDetails['UOM'] ? jobDetails['UOM'] : '',
        buying: {
          currency: jobDetails['Buying Currency'] ? jobDetails['Buying Currency'] : '',
          unitPrice: '',
          totalPrice: !jobDetails['F.Buying'] ? 0 : jobDetails['F.Buying'],
          exchRate: !jobDetails['Buying Rate'] ? 0 : jobDetails['Buying Rate'],
        },
        markup: {
          unitPrice: Number(markupUP).toFixed(4),
          totalPrice: !jobDetails['F.Mark Up'] ? '' : jobDetails['F.Mark Up'],
        },
        selling: {
          currency: jobDetails['Currency'] ? jobDetails['Currency'] : '',
          unitPrice: '',
          totalPrice: !jobDetails['F.Selling'] ? '' : jobDetails['F.Selling'],
          exchRate: !jobDetails['Rate'] ? '' : jobDetails['Rate'],
        },
      };
    },
    deleteJobCharges: function () {
      if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
        this.$showAlert('warning', 'No Job is Selected', 'Please select a Job first!'); // add "/Project" after we enable the function to query by Project.
        this.jobNoError = 'No Job is Selected';
      } else if (!this.selectedTableListToggle[0]) {
        this.$showAlert('error', 'No Job Charges is Selected', 'Please select a Job Charges to delete.');
      } else if (this.selectedTableListToggle[0].Status.includes('Cancelled')) {
        this.$showAlert('error', 'Cancelled Job Charges is Selected', 'Cancelled Job Charges cannot be deleted.');
      } else {
        this.populateDetails(this.selectedTableListToggle[0]);
        this.showDeletePopup = true;
      }
    },
    deletePopupButtonClicked: function (e) {
      switch (e) {
        case 'Delete':
          this.showDeletePopup = false;
          this.showDeletePopupWithRemarks = true;
          break;
        case 'Cancel':
          this.clearAllField();
          this.showDeletePopup = false;
          break;
      }
    },
    copyPopupButtonClicked: async function (e) {
      switch (e) {
        case 'OK':
          if (!this.selectedJobToCopy) {
            this.copyjobNoError = 'No job is Selected';
            return;
          }
          this.$fullscreenLoading('Getting Job Charges');
          this.selectedJobsListToCopy = [];
          let selected = await this.$apiCallV2('/JobCharges/GetJobChargesListing', {
            filteroption: 'JobNo',
            filtervalue: this.selectedJobToCopy['Job No'],
          });
          let toPopulate =
            selected['JobChargesListing']['JobCharges'][0]['ChargesList'] ?
              selected['JobChargesListing']['JobCharges'][0]['ChargesList']
            : [];
          this.showJobListPopup = false;
          this.showChargesTableListPopup = true;
          await this.$sleep(500);
          this.selectedJobsListToCopy = toPopulate;
          this.$fullscreenLoading();

          break;
        case 'Cancel':
          this.showJobListPopup = false;
          this.selectedJobToCopy = null;
          this.copyjobNoError = '';
          break;
      }
    },
    copyChargesPopupButtonClicked: async function (e) {
      switch (e) {
        case 'OK':
          if (this.selectedJobsToCopy.length == 0) {
            this.$showAlert('warning', 'No Job Charges is selected!', 'Please select a Job Charges first!');
            return;
          }

          let dcToSave = this.selectedJobsToCopy.map((dc) => {
            return {
              chargescode: dc['Charges Code'],
              contno: '',
              cnno: '',
              qty: dc['Qty'] ?? '',
              uom: dc['UOM'] ?? '',
              currency_famount: dc['Currency'] ?? '',
              rate_famount: '1',
              currency: dc['Currency'] ?? '',
              rate: '1',
              payeetype: dc['Payee Type'] ?? '',
              payeecode: dc['Payee Code'] ?? '',
              buying_amt: dc['Buying'] ?? '',
              adjustamt: '',
              selling_amt: dc['Selling'] ?? '',
              billcu: this.selectedBillingCustomer ? this.selectedBillingCustomer['Customer Code'] : '',
              docrefno: '',
              doctype: '',
              costcode: '',
              rebateamt: '',
              adjustment: '',
              fbuying_amt: dc['Buying'] ?? '',
              fadjustamt: '',
              fselling_amt: dc['Selling'] ?? '',
              remarks: dc['Item Remarks'] ?? '',
            };
          });

          let dataToPost = {
            action: this.action == '' ? 'N' : this.action,
            jobno: this.jobno,
            jobcharges: dcToSave ?? [],
          };
          let result = await this.$apiCallV2(`/JobCharges/SaveJobCharges`, dataToPost);
          if (result != null) {
            this.showChargesTableListPopup = false;
            this.jobChargesList = [];
            this.getJobCharges();
            if (result[0].Results == '1') {
              this.$showAlert('error', 'An Error has occurred', result[0].ErrMsg);
            } else {
              this.$showAlert('success', 'Success', 'Successfully Created Job Charges.');
            }
          } else {
            this.$showAlert('error', 'An Error has occurred', result[0]['ErrMsg']);
          }
          this.menu[6]['title'] = 'View Job Charges by Cont. No';
          this.menu[6]['icon'] = 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png';
          this.menu.forEach((m) => (m['enabled'] = true));
          break;
        case 'Cancel':
          this.selectedJobsToCopy = [];
          this.showChargesTableListPopup = false;
          this.showJobListPopup = true;
          break;
      }
    },
    deleteClicked: async function (e) {
      switch (e) {
        case 'Delete':
          // check for empty and spacing and reset to empty
          if (!this.deleteRemarks || this.deleteRemarks.trim() == '') {
            this.deleteRemarksError = 'Please enter delete remarks!';
            this.deleteRemarks = '';
          } else {
            let dataToPost = {
              action: 'D',
              jobchargesid: this.jobChargesDetails['txnid'],
              jobcharges: [
                {
                  reason: this.deleteRemarks,
                  indicator: this.jobChargesDetails['indicator'],
                  jobtxntype: this.jobChargesDetails['type'],
                },
              ],
            };
            this.showDeletePopup = false;
            this.$fullscreenLoading('Cancelling Selected Job Charges');
            let deleteResult = await this.$apiCallV2('/JobCharges/SaveJobCharges', dataToPost);
            this.$fullscreenLoading();
            this.deleteRemarks = '';
            if (deleteResult.length === 0) {
              this.$showAlert('success', 'Deleted!', `Job Charges was successfully deleted.`);
              this.$nextTick(async () => {
                this.deleteRemarksError = '';
                this.jobChargesList = [];
                this.selectedTableListToggle = [];
                this.clearAllField();
                this.showDeletePopup = false;
                this.showDeletePopupWithRemarks = false;
                await this.getJobCharges();
              });
            } else {
              this.$showAlert('error', 'Not Deleted', deleteResult[0]['ErrMsg']);
              this.$nextTick(async () => {
                this.deleteRemarksError = '';
                this.jobChargesList = [];
                this.selectedTableListToggle = [];
                this.clearAllField();
                this.showDeletePopup = false;
                this.showDeletePopupWithRemarks = false;
                await this.getJobCharges();
              });
            }
          }
          break;
        case 'Cancel':
          this.deleteRemarksError = '';
          this.deleteRemarks = '';
          this.selectedTableListToggle = [];
          this.clearAllField();
          this.showDeletePopup = false;
          this.showDeletePopupWithRemarks = false;
          // this.$nextTick(async () => await this.getJobCharges(null));
          break;
      }
    },
    downloadTextSizing: function (e) {
      this.leftMenuWidth = e[0]['contentRect']['width'];
    },
    checkRequiredFields: function () {
      return this.entryRequired.length > 0;
    },
    saveButton: async function () {
      let tempPayeeCode = '';
      let dataToPost = '';
      let dcToSave = '';
      let error = false;
      if (!this.selectedJob && !this.selectedProject && !this.freeTextJobProjNo) {
        this.$showAlert('error', 'No Job is Selected', 'Please select 1 Job or Project to do this action.'); // add "/Project" after we enable the function to query by Project.
        error = true;
      } else {
        if (this.selectedDC.length < 2) {
          let details = this.$refs['foreignCurrency'].getDetails();
          if (!this.selectedChargesCode) {
            this.chargesCodeError = 'Charges Code is required!';
            error = true;
          }
          if (this.payableChecking != '0') {
            if (!this.selectedPayeeCode) {
              this.payeeCodeError = 'Payee Code is Required!';
              error = true;
            }
            if (!this.selectedPayeeType || Object.keys(this.selectedPayeeType).length == 0) {
              this.payeeTypeError = 'Payee Type is Required!';
              error = true;
            }
            if (this.selectedPayeeType) {
              switch (this.selectedPayeeType['Party'].trim()) {
                case 'CA/FF/OA/SA':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Agent Code'] : '';
                  break;
                case 'Creditor':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Payee Code'] : '';
                  break;
                case 'AR':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Customer Code'] : '';
                  break;
                case 'Employee':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Employee Code'] : '';
                  break;
                case 'Forwarding Agent':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Frt Forwarder Code'] : '';
                  break;
                case 'Haulier':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Haulier Code'] : '';
                  break;
                case 'Port Operator':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Operator Code'] : '';
                  break;
                case 'Supplier':
                  tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Supplier Code'] : '';
                  break;
              }
            }
          }

          if (this.payableChecking != '2') {
            if (!this.selectedBillingCustomer) {
              this.billingCustomerError = 'Billing Customer is Required!';
              error = true;
            }
          }

          const [markUpDigit, markUpDec] = details['myrEquivalent']['markupTotalPrice'].split('.');
          const [sellingDigit, sellingDec] = details['myrEquivalent']['sellingTotalPrice'].split('.');

          if (
            markUpDigit?.length > 14 ||
            markUpDec?.length > 4 ||
            sellingDigit?.length > 14 ||
            sellingDec?.length > 4
          ) {
            this.$showAlert(
              'error',
              'Error',
              'Total mark up and total selling cannot exceed 14 whole digits and 2 decimals!',
            );
            error = true;
          }

          if (error) {
            return;
          }

          dcToSave = [
            {
              chargescode: this.selectedChargesCode['Income Code'],
              contno: this.selectedCont ? this.selectedCont['Cont No'] : '',
              cnno: this.selectedCN ? this.selectedCN['Consignment No'] : '',
              qty: details.quantity ? details.quantity : '1',
              uom:
                details['uom'] ?
                  details['uom']['UOM Code'] ?
                    details['uom']['UOM Code']
                  : details['uom']
                : '',
              currency_famount: details['buying']['currency'] ? details['buying']['currency']['Currency Code'] : '',
              rate_famount: details['buying']['exchRate'] ? details['buying']['exchRate'] : '',
              currency: details['selling']['currency'] ? details['selling']['currency']['Currency Code'] : '',
              rate: details['selling']['exchRate'] ? details['selling']['exchRate'] : '',
              payeetype: this.selectedPayeeType ? this.selectedPayeeType['Party Code'] : '',
              payeecode: tempPayeeCode,
              buying_amt:
                details['myrEquivalent']['buyingTotalPrice'] ? details['myrEquivalent']['buyingTotalPrice'] : '',
              adjustamt:
                details['myrEquivalent']['markupTotalPrice'] ? details['myrEquivalent']['markupTotalPrice'] : '',
              selling_amt:
                details['myrEquivalent']['sellingTotalPrice'] ? details['myrEquivalent']['sellingTotalPrice'] : '',
              billcu: this.selectedBillingCustomer ? this.selectedBillingCustomer['Customer Code'] : '',
              docrefno: this.jobChargesDetails['docRefNo'] ? this.jobChargesDetails['docRefNo'] : '',
              doctype: this.jobChargesDetails['docType'] ? this.jobChargesDetails['docType'] : '',
              costcode: this.jobChargesDetails['costCode'] ? this.jobChargesDetails['costCode']['Cost Code'] : '',
              rebateamt: this.jobChargesDetails['vendorRebate'] ? this.jobChargesDetails['vendorRebate'] : '',
              adjustment:
                this.jobChargesDetails['AdjType'] ?
                  this.jobChargesDetails['AdjType']['AdjstType'] == 'Adjustment' ?
                    'Y'
                  : 'N'
                : '',
              fbuying_amt: details['buying']['totalPrice'] ? details['buying']['totalPrice'] : '',
              fadjustamt: details['markup']['totalPrice'] ? details['markup']['totalPrice'] : '',
              fselling_amt: details['selling']['totalPrice'] ? details['selling']['totalPrice'] : '',
              remarks: this.jobChargesDetails['remark'] ? this.jobChargesDetails['remark'] : '',
            },
          ];
        } else {
          dcToSave = this.selectedDC.map((dc) => {
            return {
              chargescode: dc['Charge Code'],
              contno: '',
              cnno: '',
              qty: dc['Qty'] ?? '',
              uom: dc['UOM'] ?? '',
              currency_famount: dc['Currency'] ?? '',
              rate_famount: '1',
              currency: dc['Currency'] ?? '',
              rate: '1',
              payeetype: dc['Payee Type'] ?? '',
              payeecode: dc['Payee Code'] ?? '',
              buying_amt: dc['Buying'] ?? '',
              adjustamt: '',
              selling_amt: dc['Selling'] ?? '',
              billcu: this.selectedBillingCustomer ? this.selectedBillingCustomer['Customer Code'] : '',
              docrefno: '',
              doctype: '',
              costcode: '',
              rebateamt: '',
              adjustment: '',
              fbuying_amt: dc['Buying'] ?? '',
              fadjustamt: '',
              fselling_amt: dc['Selling'] ?? '',
              remarks: dc['Item Remarks'] ?? '',
            };
          });
        }

        dataToPost = {
          action: this.action == '' ? 'N' : this.action,
          jobno: this.selectedJob ? this.selectedJob['Job No'] : this.jobno,
          jobcharges: dcToSave ?? [],
        };

        if (this.action == 'E') {
          dataToPost['jobchargesid'] = this.jobChargesDetails['txnid'];
        }
        let result = await this.$apiCallV2(`/JobCharges/SaveJobCharges`, dataToPost);
        if (result[0]['JobChargesID']) {
          if (this.action == 'N') {
            this.$showAlert('success', 'Success', 'Successfully Created Job Charges.');
          } else {
            this.$showAlert('success', 'Success', 'Successfully Edited Job Charges.');
          }
          this.clearAllField();
          this.jobChargesList = [];
          this.getJobCharges();
          this.openInputs = false;
        } else if (result == null) {
          this.$showAlert('error', 'An Error has occurred', errorMessage);
        } else {
          this.$showAlert('error', 'An Error has occurred', result[0]['ErrMsg']);
        }
      }
      // to reset action after saved to allowed selection on table box
      this.action = '';
    },
    cancelButton: async function () {
      if (this.action == 'E') {
        let confirm = await this.$showAlert(
          'warning',
          'Are you sure you want to quit?',
          'Please remember to save your changes before exiting. ',
          [
            { text: 'Confirm', textColor: 'white', color: 'indianred' },
            { text: 'Cancel', textColor: 'white', color: 'gray' },
          ],
        );

        if (confirm === 'Cancel') {
          return;
        }
      }

      this.clearAllField();
      this.openInputs = false;
      this.action = '';
      this.editSelling = false;
    },
    saveJobCharges: function () {
      if (this.selectedTableListToggle.length == 0) {
        this.$showAlert('error', 'No Job Charges Selected', 'Please select at least 1 Job Charges to save.');
      } else {
        this.isSelect = false;
      }
    },
    getJobCharges: async function (hide) {
      this.$fullscreenLoading('Getting Job Charges List');
      let dataToPost = {
        tmptblnaming: new Date().formatString('yyyyMMddHHmm'),
        groupby: 'Job',
        strcust: '',
        jobtype: '',
        datetype: 'Job Date',
        startgroup: this.selectedJob ? this.selectedJob['Job No'] : this.freeTextJobProjNo,
        endgroup: this.selectedJob ? this.selectedJob['Job No'] : this.freeTextJobProjNo,
        asat: new Date().formatString('yyyy-MM-dd'),
        jobstatus: 0,
        code: 0,
        strcode: '',
        rpttype: 'SUMBYJOB',
      };
      try {
        let tempGetCostingAnalysisSumByJobData = await this.$apiCallV2(`/JobCosting/GetJobCosting`, dataToPost);
        if (tempGetCostingAnalysisSumByJobData) {
          this.getCostingAnalysisSumByJobData['amtBilledExclTax'] =
            tempGetCostingAnalysisSumByJobData.length > 0 ?
              this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Amt Billed Excl Tax'])
            : 0;
          this.getCostingAnalysisSumByJobData['tax'] =
            tempGetCostingAnalysisSumByJobData.length > 0 ?
              this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Tax'])
            : 0;
          this.getCostingAnalysisSumByJobData['costExclTax'] =
            tempGetCostingAnalysisSumByJobData.length > 0 ?
              this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Cost Excl Tax'])
            : 0;
          this.getCostingAnalysisSumByJobData['grossProfit'] =
            tempGetCostingAnalysisSumByJobData.length > 0 ?
              this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Gross Profit'])
            : 0;
          this.getCostingAnalysisSumByJobData['gProfitMargin'] =
            tempGetCostingAnalysisSumByJobData.length > 0 ?
              this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['G. Profit Margin %'])
            : 0;
          this.jobStatusIndicator = tempGetCostingAnalysisSumByJobData[0]['Job Completed'] ?? -1;
        } else {
          this.clearCostingAnalysisSum();
        }
      } catch {
        this.clearCostingAnalysisSum();
      }
      let jobChargesListing = await this.$apiCallV2('/JobCharges/GetJobChargesListing', {
        filteroption: 'JobNo',
        filtervalue: this.jobno,
      });
      //check if the jobno is valid or not by reading jobchargeslisting if is empty meaning there is no jobno in the system hence return false
      this.validJobNo = jobChargesListing ? true : false;
      this.defaultBillingCustomer =
        jobChargesListing ? jobChargesListing['JobChargesListing']['JobCharges'][0]['Billing Customer'] : null;
      this.jobSummaryList = [];
      this.jobSummaryList = jobChargesListing['JobChargesListing']?.['JobCharges'][0]['JobSummary'] ?? [];
      this.jobSummaryListTableDataType = {
        // available data type string, number, date, currency
        Buying: 'currency',
        'Mark Up': 'currency',
        Selling: 'currency',
      };

      let tempService = jobChargesListing['JobChargesListing']?.['JobCharges'][0]['Service'] ?? [];
      this.serviceList =
        !tempService ? null : (
          tempService.map((item) => {
            return {
              Service: item.Description,
              Remarks: item.Remarks,
            };
          })
        );
      let chargesList = jobChargesListing['JobChargesListing']?.['JobCharges'][0]['ChargesList'] ?? [];
      let tempAccruedRev = 0;
      let tempAccruedRevForeign = 0;
      let tempAccruedExpenses = 0;
      let tempAccruedExpensesForeign = 0;
      if (chargesList.length > 0) {
        const addStyle = (chargesList, list) => {
          return chargesList.map((item) => {
            let obj = Object.assign({}, item);
            if (item.Billed == 'Pending') {
              tempAccruedRev += parseInt(item.Selling); //Total selling amount that Billed column is "Pending".
              tempAccruedRevForeign += parseInt(item['F.Selling']); //Total foreign selling amount that Billed column is "Pending".
            }
            if (item.Paid == 'Pending') {
              tempAccruedExpenses += parseInt(item.Buying); //Total buying amount that Paid column is "Pending".
              tempAccruedExpensesForeign += parseInt(item['F.Buying']); //Total foreign buying amount that Paid column is "Pending".
            }
            this.accruedRev = this.$currencyFormat(tempAccruedRev);
            this.accruedRevForeign = this.$currencyFormat(tempAccruedRevForeign);
            this.accruedExpenses = this.$currencyFormat(tempAccruedExpenses);
            this.accruedExpensesForeign = this.$currencyFormat(tempAccruedExpensesForeign);
            list.forEach((data) => {
              if (data == 'Billed') {
                obj[data] =
                  !item.Billed.includes('Billed') ?
                    item.Billed.includes('Pending') ?
                      '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white ; pointer-events: none">Pending</div>'
                    : '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">N/A</div>'
                  : '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white; pointer-events: none">Billed</div>';
              } else if (data == 'Paid') {
                obj[data] =
                  !item.Paid.includes('Paid') ?
                    item.Paid.includes('Pending') ?
                      '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white ;pointer-events: none">Pending</div>'
                    : '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">N/A</div>'
                  : '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white; pointer-events: none">Paid</div>';
              } else {
                if (item.Status.includes('Pending')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white ;pointer-events: none">Pending</div>';
                } else if (item.Status.includes('N/A')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">N/A</div>';
                } else if (item.Status.includes('Completed')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white; pointer-events: none">Completed</div>';
                } else if (item.Status.includes('Cancelled')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">Cancelled</div>';
                }
              }
            });
            return obj;
          });
        };

        let tempjob = addStyle(chargesList, ['Billed', 'Paid', 'Status']);
        if (hide == 'hide') {
          this.jobChargesList = tempjob.filter((tempjob) => tempjob.Indicator != 'C');
        } else {
          this.jobChargesList = tempjob;
        }

        this.tableDataType = {
          // available data type string, number, date, currency
          'F.Buying': 'currency',
          Buying: 'currency',
          'F.Mark Up': 'currency',
          'Mark Up': 'currency',
          'F.Selling': 'currency',
          Selling: 'currency',
          'AP Tax Amt': 'currency',
          'AP Net Inc Tax': 'currency',
          'AR Net Inc Tax': 'currency',
          Buying: 'currency',
          'Mark Up': 'currency',
          Selling: 'currency',
        };
        this.tableListToggle = [];

        this.$nextTick(() => {
          this.jobChargesList.forEach((item) => this.tableListToggle.push(item));
          this.tableListToggleDataType = this.tableDataType;
          //this.selectedTableListToggle = this.selectedJobCharges;
          this.viewMode = true;
        });
      }
      this.$fullscreenLoading();
    },
    getJobs: async function (currentData, ...e) {
      const [newSelectedObject, oldSelectedObject] = e;

      if (!newSelectedObject && this.freeTextJobProjNo == '') {
        this.clearCostingAnalysisSum(); //if no job or proj no at all then just clear everything
        this.jobno = '';
        this.tableListToggle = [];
      } else if (
        currentData == 'getJobNo' &&
        ((newSelectedObject && newSelectedObject['Job No'] != oldSelectedObject?.['Job No']) ||
          (this.freeTextJobProjNo != '' && this.freeTextJobProjNo != this.jobno))
      ) {
        this.loading = true;
        this.$fullscreenLoading('Getting Job...');
        this.viewMode = false;
        this.jobno = newSelectedObject ? newSelectedObject['Job No'] : this.freeTextJobProjNo;
        this.containerList = [];
        this.jobChargesList = [];
        this.containerList = await this.$apiCallV2(
          `/JobCharges/GetListJobContainer?jobno=${newSelectedObject ? newSelectedObject['Job No'] : this.freeTextJobProjNo}`,
        );
        this.consignmentlist = await this.$apiCallV2(
          `/JobCharges/GetListJobConsignments?jobno=${newSelectedObject ? newSelectedObject['Job No'] : this.freeTextJobProjNo}`,
        );
        //quotationList
        this.quotationList = await this.$apiCallV2(`/JobCharges/GetQuotationListing`, {
          jobno: this.jobno,
          filterbillto: 'Y',
        });
        this.$fullscreenLoading();
        this.getJobCharges();
        this.loading = false;
      } else if (
        currentData == 'getProjectNo' &&
        ((newSelectedObject && newSelectedObject['Project No'] != oldSelectedObject?.['Project No']) ||
          (this.freeTextJobProjNo != '' && this.freeTextJobProjNo != this.projectno))
      ) {
        this.projectno = newSelectedObject['Project No'];
        this.loading = true;
        this.$fullscreenLoading('Getting Job Charges List');
        this.jobChargesList = [];
        let dataToPost = {
          tmptblnaming: new Date().formatString('yyyyMMddHHmm'),
          groupby: 'Job',
          strcust: '',
          jobtype: '',
          datetype: 'Job Date',
          startgroup: oldSelectedObject['Job No'],
          endgroup: oldSelectedObject['Job No'],
          asat: new Date().formatString('yyyy-MM-dd'),
          jobstatus: 0,
          code: 0,
          strcode: '',
          rpttype: 'SUMBYJOB',
        };
        let tempGetCostingAnalysisSumByJobData = await this.$apiCallV2(`/JobCosting/GetJobCosting`, dataToPost);
        let jobChargesListing = await this.$apiCallV2('/JobCharges/GetJobChargesListing', {
          filteroption: 'project',
          filtervalue: this.projectno,
        });
        this.validJobNo = jobChargesListing.length > 0 ? true : false;
        this.defaultBillingCustomer = jobChargesListing['JobChargesListing']['JobCharges'][0]['Billing Customer'];
        this.getCostingAnalysisSumByJobData['amtBilledExclTax'] =
          this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Amt Billed Excl Tax']) || 0;
        this.getCostingAnalysisSumByJobData['tax'] =
          this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Tax']) || 0;
        this.getCostingAnalysisSumByJobData['costExclTax'] =
          this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Cost Excl Tax']) || 0;
        this.getCostingAnalysisSumByJobData['grossProfit'] =
          this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['Gross Profit ']) || 0;
        this.getCostingAnalysisSumByJobData['gProfitMargin'] =
          this.$currencyFormat(tempGetCostingAnalysisSumByJobData[0]['G. Profit Margin %']) || 0;
        this.jobStatusIndicator = tempGetCostingAnalysisSumByJobData[0]['Job Completed'];

        let chargesList = jobChargesListing['JobChargesListing']['JobCharges'][0]['ChargesList'];
        this.serviceList = jobChargesListing['JobChargesListing']['JobCharges'][0]['Service'];
        this.serviceList = chargesList;
        this.serviceList = jobChargesListing['JobChargesListing']['JobCharges'][0]['Service'].map((item) => {
          return {
            Service: item.StatusDescription,
            Remarks: item.Remarks,
          };
        });

        this.legend = jobChargesListing['Legend'];
        const addStyle = (chargesList, list) => {
          return chargesList.map((item) => {
            let obj = Object.assign({}, item);
            if (item.Billed == 'Pending') {
              this.accruedRev += parseInt(item.Selling);
            }
            if (item.Paid == 'Pending') {
              this.accruedExpenses += parseInt(item.Buying);
            }

            list.forEach((data) => {
              if (data == 'Billed') {
                obj[data] =
                  !item.Billed.includes('Billed') ?
                    item.Billed.includes('Pending') ?
                      '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white">Pending</div>'
                    : '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white">N/A</div>'
                  : '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white">Billed</div>';
              } else if (data == 'Paid') {
                obj[data] =
                  !item.Paid.includes('Paid') ?
                    item.Paid.includes('Pending') ?
                      '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white ;pointer-events: none">Pending</div>'
                    : '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">N/A</div>'
                  : '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white; pointer-events: none">Paid</div>';
              } else {
                if (item.Status.includes('Pending')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: orange; padding: 5px; border-radius:5px; color: white ;pointer-events: none">Pending</div>';
                } else if (item.Status.includes('N/A')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">N/A</div>';
                } else if (item.Status.includes('Completed')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: green; padding: 5px; border-radius:5px; color: white; pointer-events: none">Completed</div>';
                } else if (item.Status.includes('Cancelled')) {
                  obj[data] =
                    '<div height="15" width="15" style="background-color: gray; padding: 5px; border-radius:5px; color: white;pointer-events: none">Cancelled</div>';
                }
              }
            });
            return obj;
          });
        };

        this.jobChargesList = addStyle(chargesList, ['Billed', 'Paid', 'Status']);
        this.loading = false;
        this.$fullscreenLoading();
      }
    },
    getAllData: async function (e) {
      this.containerList = await this.$apiCallV2(`/JobCharges/GetListJobContainer?jobno=${e['Job No']}`);
      this.consignmentlist = await this.$apiCallV2(`/JobCharges/GetListJobConsignments?jobno=${e['Job No']}`);
      this.quotationList = await this.$apiCallV2(`/JobCharges/GetQuotationListing`, {
        jobno: e['Job No'],
        filterbillto: 'Y',
      });
      this.selectedQuery = this.queryBy[0];
      this.jobChargesDetails['AdjType'] = { item: 1, AdjstType: 'Adjustment' };
    },
    jobChargesSelected: async function (row, selected) {
      this.oldTxnID = this.oldTxnID == '' ? row['TxnID'] : this.oldTxnID;

      if (this.action == 'E' && selected && this.openInputs) {
        if (row['TxnID'] == this.oldTxnID) {
          return;
        }
        let confirm = await this.$showAlert(
          'warning',
          'Are you sure you want to continue ?',
          'Please save your changes before selecting new Job Charges Details',
          [
            { text: 'Confirm', textColor: 'white', color: 'indianred' },
            { text: 'Cancel', textColor: 'white', color: 'gray' },
          ],
        );

        if (confirm === 'Confirm') {
          //validation check here so that can re-select the previous table selection
          if ((await this.editChecking(this.editSelling ? 'Update Selling' : 'Edit Job Charges')) == true) {
            //calling menuclicked here will also include the validation checking
            // if the user clicks on confirm, old selected job will change
            this.oldTxnID = row['TxnID'];

            if (this.editSelling) {
              this.menuClicked({ title: 'Update Selling' }); //mimic menuClicked function to block certain fields
            } else {
              this.menuClicked({ title: 'Edit Job Charges' }); //mimic menuClicked function
            }
            return;
          }
        }

        this.selectedTableListToggle = [];
        const selectedTableListToggleTemp = [this.jobChargesList.find((job) => job['TxnID'] == this.oldTxnID)]; //change the highlighted row to the old one
        this.showJobCharges = false;
        this.$nextTick(() => {
          this.showJobCharges = true;
          this.selectedTableListToggle = selectedTableListToggleTemp;
        });

        return;
      } else if (this.action == 'N' && selected) {
        this.selectedTableListToggle = [];
        return;
      } else if (this.action == 'V' && selected) {
        this.oldTxnID = row['TxnID'];
        this.populateDetails(row);
        if (this.quotationList.length == 1) {
          this.selectedQuotation = this.quotationList[0];
          this.quotationSelected(this.selectedQuotation);
        } else {
          this.defaultChargesList = [];
          this.selectedQuotation = null;
        }
      }
    },
    // currency format for default charges
    formatCurrDC(i) {
      return i.Currency == 'MYR' ? this.$currencyFormat(i.Selling) : this.$currencyFormat(i.FAmount);
    },
    getListDetails: function () {
      let listPromises = [];

      listPromises.push(
        this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'JOB' }).then((result) => {
          this.jobNoList = result;
        }),
      );

      listPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PARTY' }).then((result) => {
          this.payeeTypeList = result;
        }),
      );

      listPromises.push(
        this.$apiCallV2('/Master/GetListMaster', { masterfile: 'BILLCUST' }).then((result) => {
          this.billCustList = result;
        }),
      );

      listPromises.push(
        this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'CUSTOMER' }).then((result) => {
          this.customerList = result;
        }),
      );

      listPromises.push(
        this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'CHARGESCODE', module: 'FINPAYJOB' }).then((result) => {
          this.chargeCodeList = result;
        }),
      );

      listPromises.push(
        this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'COSTCODE' }).then((result) => {
          this.costCodeList = this.$deepTrimJsonV3(result);
        }),
      );

      return listPromises;
    },
    clearCostingAnalysisSum() {
      this.getCostingAnalysisSumByJobData['amtBilledExclTax'] = 0;
      this.getCostingAnalysisSumByJobData['tax'] = 0;
      this.getCostingAnalysisSumByJobData['costExclTax'] = 0;
      this.getCostingAnalysisSumByJobData['grossProfit'] = 0;
      this.getCostingAnalysisSumByJobData['gProfitMargin'] = 0;
      this.jobStatusIndicator = -1;
      this.accruedRev = 0;
      this.accruedExpenses = 0;
      this.accruedExpensesForeign = 0;
      this.accruedRevForeign = 0;
    },
    async editChecking(field) {
      let canEdit = true;
      let status = '';
      if (this.selectedTableListToggle.length == 0) {
        await this.$showAlert('error', 'No Job Charges Selected', 'Please select a job charges first!');
        return false;
      }
      if (field == 'Edit Job Charges') {
        //edit job charges
        if (
          (this.selectedTableListToggle[0]['Billed'].includes('Billed') &&
            this.selectedTableListToggle[0]['Paid'].includes('Paid')) ||
          this.selectedTableListToggle[0]['Status'].includes('Completed')
        ) {
          status = 'completed';
        } else if (this.selectedTableListToggle[0]['Billed'].includes('Billed')) {
          status = 'billed';
        } else if (this.selectedTableListToggle[0]['Paid'].includes('Paid')) {
          status = 'paid';
        } else if (this.selectedTableListToggle[0]['Status'].includes('Cancelled')) {
          status = 'cancelled';
        }
      } else {
        //Update Selling, allow Update Selling only if not yet billed or completed.
        if (
          this.selectedTableListToggle[0]['Billed'].includes('Billed') ||
          this.selectedTableListToggle[0]['Status'].includes('Completed')
        ) {
          status = 'billed or completed';
        }
      }
      if (status != '') {
        await this.$showAlert('error', 'Cannot Edit!', `Cannot edit charges that have been ${status}`);
        canEdit = false;
      }
      return canEdit;
    },
    async jobListRefresh(focus) {
      if (!focus) {
        this.$fullscreenLoading('Getting Job List...');
        this.jobNoList = await this.$apiCallV2(`/Master/GetListMaster`, {
          masterfile: 'JOB',
          toprow: this.settingsitem,
        });
        this.$fullscreenLoading();
      }
    },
  },
  async mounted() {
    await this.sasControlFunction();
    this.boxesSectionHeight = this.$refs['boxes-section'].getBoundingClientRect().height;

    if (!this.resizeObserver) {
      this.resizeObserver = new ResizeObserver(this.downloadTextSizing);
    }
    this.resizeObserver.observe(this.$refs['leftMenu']);

    const getListDetailsPromises = this.getListDetails().map((promise) => {
      return promise.then(() => {
        this.mountedPromisesFulfilledCount++;
      });
    });
    this.mountedPromises = this.mountedPromises.concat(getListDetailsPromises);

    await Promise.allSettled(this.mountedPromises);

    //enabled all menu button after all mounted promises are fulfilled
    if (this.mountedPromisesFulfilledCount >= this.mountedPromises.length) {
      this.jobNoLoad = false;
    }

    this.$fullscreenLoading('Getting Job...');
    let tempSettingsitem = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=TAS_MAXJOBSELECT');
    this.settingsitem = tempSettingsitem[0]['SettingsValue'];
    let tempVendorRebate = await this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=EnableVendorRebate');
    this.enableVendorRebate = tempVendorRebate[0]['SettingsValue'];

    this.$fullscreenLoading('Getting Project...');
    this.projectNoList = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'projectno' });

    this.queryBy = await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'JOBCHARGESVIEWOPTION' });
    this.selectedQuery = this.queryBy[0];

    if (this.$route.query['jobNo']) {
      this.jobno = this.$route.query['jobNo'];
      this.selectedJob = this.jobNoList.find((i) => {
        return i['Job No'] == this.jobno;
      });
    }
    await this.getAllData(this.selectedJob == null ? '' : this.selectedJob);
    this.$fullscreenLoading();

    if (this.selectedJob) this.getJobCharges(this.selectedJob);
    else this.$refs['jobnoinput'].setFocus();
    // this.selectedJob ? this.getJobCharges(this.selectedJob) : this.$refs['jobnoinput'].setFocus();
  },
  watch: {
    selectedChargesCode: function (val) {
      if (val) {
        this.payableChecking = val['Payable'];
        this.billingCustomerError = '';
        this.payeeCodeError = '';
        this.payeeTypeError = '';
        this.selectedPayeeType = null;
        this.selectedPayeeCode = null;
        this.billingCustomer = null;
      }
    },
    selectedQuery: function (val) {
      if (val) {
        this.selectedQuery = val;
      }
    },
    selectedJob: async function (val, previousSelected) {
      if (val) {
        this.isJobEmpty = false;
        //prevent it from running when the selectedJob is the same as the previous one which is reset the tablebox to empty
        if (previousSelected) {
          if (val['Job No'] !== previousSelected['Job No']) {
            this.tableListToggle = [];
          }
        }
        this.clearAllField();
      } else {
        this.isJobEmpty = true;
        this.tableListToggle = [];
        this.jobno = '';
      }
    },
    selectedCont: function (val) {
      if (val && !this.freeTextJobProjNo) {
        this.jobno = val['Job No'];
        this.selectedJob = this.jobNoList.find((i) => {
          return i['Job No'] == val['Job No'];
        });
      }
    },
    selectedCN: function (val) {
      if (val && !this.freeTextJobProjNo) {
        this.jobno = val['Job No'];
        this.selectedJob = this.jobNoList.find((i) => {
          return i['Job No'] == val['Job No'];
        });
      }
    },
    tableListToggle: {
      deep: true,
      handler(val) {
        if (val) {
          let sellingCurrency = Array.from(new Set(val.map((d) => d['Currency'])));
          let buyingCurrency = Array.from(new Set(val.map((d) => d['Buying Currency'])));
          this.sellingFCurr = sellingCurrency.length == 1 ? sellingCurrency[0] : '';
          this.buyingFCurr = buyingCurrency.length == 1 ? buyingCurrency[0] : '';
          this.sellingMultiCurr = sellingCurrency.length > 1;
          this.buyingMultiCurr = buyingCurrency.length > 1;
        }
      },
    },
  },
  computed: {
    // topWidth: function() {
    //   return {
    //     width: this.openInputs ?  `calc(100% - ${this.$refs['menuWidth'].getBoundingClientRect().width} - 300px)` :`calc(100% - ${this.$refs['menuWidth'].getBoundingClientRect().width} )`
    //   }
    // // },
    loadingBarContainerStyling: function () {
      return {
        width: `${this.leftMenuWidth - 10}px`,
        fontSize: this.leftMenuWidth < 100 ? '0.8em' : '1em',
      };
    },
    loadingBarText: function () {
      const loadingText = this.leftMenuWidth < 100 ? '' : 'Loading ';
      const percentage = ((this.mountedPromisesFulfilledCount / (this.mountedPromises.length || 1)) * 100).toFixed(0);
      // (this.mountedPromises.length || 1) to prevent division by 0,
      // if length is 0, divide by 1 instead. 0/1 is still 0.

      return `${loadingText}${percentage}%`;
    },
    loadingBarStyling: function () {
      return {
        width: `${(this.mountedPromisesFulfilledCount / (this.mountedPromises.length || 1)) * 100}%`,
        // (this.mountedPromises.length || 1) to prevent division by 0,
        // if length is 0, divide by 1 instead. 0/1 is still 0.
      };
    },
    jobStatus: function () {
      switch (this.jobStatusIndicator) {
        case 0:
          return { text: 'Pending', color: 'orange' };
        case 1:
          return { text: 'Completed', color: 'green' };
        default:
          return { text: 'N/A', color: 'gray' };
      }
    },
    tableHeight: function () {
      return {
        overflow: 'auto',
        height: `calc(100% - 90px)`,
        width: '100%',
      };
    },
    // leftSectionwidth: function(){
    //   return{
    //     width: `${this.mainSectionwidth - this.rightSectionwidth}px`
    //   }
    // }
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.job-charges-main {
  font-size: 12px;
  padding: 10px 10px 10px 45px;
  width: 100%;
  height: 100%;
  display: flex;
  // flex-direction: row;
  // position: static;

  > .job-charges-main-left {
    height: 100%;
    width: 100%;

    // > .top-section, > .bottom-section {
    //   border-radius: 5px;
    //   width: 100%;
    //   // height: 50%;
    // display: flex;
    // }

    > .top-section {
      // overflow: hidden;
      height: 100%;
      width: 100%;
      display: flex;

      > .top-section-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        margin-left: 5px;

        > .top-filter-section {
          background-color: white;
          padding: 3px;
          display: flex;
          // height: 100%;
          border-radius: 5px;

          > :first-child {
            max-width: 20%;
          }

          > :not(:first-child) {
            margin-left: 5px;
          }
        }

        > .top-details-section {
          height: 100%;
          margin-top: 5px;
          display: flex;
          position: static;
          // overflow: hidden;

          > .top-left-details,
          > .top-right-details {
            width: 100%;
            height: 100%;
          }

          > .top-left-details {
            display: flex;
            flex-direction: column;

            > .left-section-boxes-container {
              display: flex;
              margin-bottom: 5px;

              > .boxes-item {
                background-color: white;
                border-radius: 5px;
                width: 100%;
                // min-height: 50px;
                // max-height: 50px;
                display: flex;
                flex-direction: column;
                text-align: center;
                justify-content: space-between;
                padding-left: 2px;
                padding-right: 2px;

                &:not(:first-child) {
                  margin-left: 5px;
                }
                > .space {
                  padding-bottom: 5px;
                }
              }
            }
          }

          > .top-right-details {
            background-color: white;
            border-radius: 5px;
            padding: 5px;

            > .buttons {
              flex-basis: content;
              text-align-last: right;
            }
          }
        }
      }
    }

    > .bottom-section {
      background-color: white;
      padding: 5px;
      height: 100%;
      width: 100%;

      > .bottom-section-content {
        display: flex;
        width: 100%;
        // overflow: auto;
        height: 100%;
        margin-left: 5px;
        border-radius: 5px;

        > .bottom-tablebox {
          min-width: 50%;

          &:not(:first-child) {
            margin-left: 5px;
          }
        }
      }
    }
  }
  > .job-charges-main-right {
    width: 100%;
    margin-left: 5px;
    border-radius: 5px;
    position: sticky;

    > .right-menu-home-container {
      width: 100%;
      height: 100%;
      overflow: hidden;

      > .pending-trips-container {
        // height: 100%; moved to template for reactivity
        width: 100%;
        transition: height 0.3s;
      }

      > .trips-history-container {
        // height: 100%; moved to template for reactivity
        width: 100%;
        transition: height 0.3s;

        > .trips-history-header {
          width: fit-content;
          font-weight: bold;
          user-select: none;
          cursor: pointer;

          > img {
            transition: 0.3s;
          }
        }

        > .trips-history-box {
          border: 1px solid black;
          border-radius: 3px;
          overflow-y: auto;
          transition: height 0.3s;

          > .trips-history-loading-text {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          > .no-trips-history {
            width: 100%;
            display: flex;
            justify-content: center;
          }

          > .trips-history-list {
            display: flex;
            flex-direction: column;

            // > .hms-trips-content {
            //   background-color: white;
            //   border: 1px solid black;
            //   width: calc(100% - 10px); // 100% minus left and right margins
            //   // padding: 5px;
            //   // margin: 5px;
            //   position: relative;
            //   // padding-right: 25px;
            //   height: fit-content;

            //   &:hover {
            //     background-color: #a6acff;
            //     /* box-shadow: inset 0 0 1000px white !important; */
            //     cursor: pointer;
            //     color: white;
            //   }

            //   > .trips-row {
            //     display: flex;
            //     align-items: flex-start;

            //     > .trips-left {
            //       width: fit-content;
            //       flex-grow: 1;
            //       font-weight: bold;
            //       padding-right: 5px;
            //     }

            //     > .trips-right {
            //       // max-width: 100px;
            //       width: fit-content;
            //       text-align: right;
            //       white-space: normal;
            //     }
            //   }

            //   > .trips-tooltip {
            //     position: absolute;
            //     right: 3px;
            //     bottom: 3px;
            //   }
            // }
          }
        }
      }
    }
  }
}

.pending-trips-header {
  width: fit-content;
  font-weight: bold;
  user-select: none;
  cursor: pointer;
  > img {
    transition: 0.3s;
  }
}
.content-3-column {
  width: calc(100% / 3);
  margin-right: 5px;
}

.tablebox-container {
  padding: 5px;
  border-radius: 5px;
  background-color: white;
  flex-grow: 1;
}

.currency {
  height: fit-content;
  text-align: end;
  width: 100%;
  margin-right: 10px;
}

.currency-highlight {
  background-color: #7b9aff;
  text-align: end;
  margin: 5px;
}

.save-button {
  background-color: green;
  margin-left: 5px;
  margin-right: 5px;
  color: white;
  margin-bottom: 5px;
}

.cancel-button {
  background-color: red;
  margin-left: 5px;
  margin-right: 5px;
  color: white;
  margin-bottom: 5px;
}

.block-section {
  background-color: #e1e3ff;
  padding: 1px 5px 0px 5px;
  color: black;
  // margin-top: -4.5px;
  height: 24px;
  // width: 30px;
  text-align: center;
}

.left-menu {
  // display: flex;
  justify-content: center;
  // overflow-y: auto;
  // overflow-y: auto;
  // height: 100%;

  > .loading-bar-container {
    border: 1px solid rgba(0, 0, 0, 0.2);
    flex-grow: 1;
    height: 15px;
    position: absolute;
    bottom: 15px;
    z-index: 101;

    > .loading-bar-text {
      width: 100%;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
    }

    > .loading-bar {
      height: 100%;
      background-color: rgb(60, 211, 0);
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 0;
      z-index: 9;
    }
  }
}
.pending-trips-box {
  // border: 1px solid black;
  border-radius: 3px;
  overflow-y: auto;
  transition: height 0.3s;
  > .pending-trips-loading-text {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  > .no-pending-trips {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  > .pending-trips-list {
    display: flex;
    flex-direction: column;
    > .hms-trips-content {
      // background-color: white;
      border: 1px solid black;
      width: calc(100% - 10px); // 100% minus left and right margins
      // padding: 5px;
      margin: 5px;
      position: relative;
      // padding-right: 25px;
      height: fit-content;

      > .trips-row {
        display: flex;
        align-items: flex-start;
        > .trips-left {
          width: fit-content;
          flex-grow: 1;
          font-weight: bold;
          padding-right: 5px;
        }
        > .trips-right {
          // max-width: 100px;
          width: fit-content;
          text-align: right;
          white-space: normal;
        }
      }
      > .trips-tooltip {
        position: absolute;
        right: 3px;
        bottom: 3px;
      }
    }

    .dc-content {
      background-color: white;
      color: black;
      cursor: pointer;
      border: 1px solid black;
      width: calc(100% - 10px);
      margin: 5px;
      position: relative;
      height: fit-content;
    }

    .dc-content:hover {
      background-color: lightgray;
    }

    .dc-content.selected {
      background-color: gray;
      color: white;
    }

    .dc-content.selected:hover {
      opacity: 0.8;
    }
  }
}
.foreign-currency-style {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 30px;
  flex-direction: row;
}
.disabled-section {
  pointer-events: none;
  opacity: 0.6;
}
.disabled-section input,
.disabled-section div {
  cursor: not-allowed;
}
.expired {
  background-color: red;
  color: white;
  padding-left: 5px;
  text-align: center;
  border-radius: 4px;
}
.row-items {
  padding: 0 2px 0 2px;
}
.copy-charges-popup-container {
  ::v-deep {
    // deep needed to target the content class inside the PopupV2 component
    .content {
      // NOT the content class for slot, but content class inside PopupV2 itself
      overflow: visible;
    }
  }
}
</style>
